var xn = Object.defineProperty;
var Cn = (e, t, r) => t in e ? xn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Kt = (e, t, r) => Cn(e, typeof t != "symbol" ? t + "" : t, r);
import rt, { createContext as dr, useContext as Vr, useState as hr, useEffect as z, useMemo as Pt, useCallback as J, useRef as j, useReducer as Pn } from "react";
import { ApolloLink as Br, Observable as An } from "@apollo/client";
var Zt = { exports: {} }, kt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rr;
function jn() {
  if (Rr) return kt;
  Rr = 1;
  var e = rt, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(u, h, l) {
    var p, g = {}, k = null, O = null;
    l !== void 0 && (k = "" + l), h.key !== void 0 && (k = "" + h.key), h.ref !== void 0 && (O = h.ref);
    for (p in h) n.call(h, p) && !o.hasOwnProperty(p) && (g[p] = h[p]);
    if (u && u.defaultProps) for (p in h = u.defaultProps, h) g[p] === void 0 && (g[p] = h[p]);
    return { $$typeof: t, type: u, key: k, ref: O, props: g, _owner: s.current };
  }
  return kt.Fragment = r, kt.jsx = c, kt.jsxs = c, kt;
}
var Et = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Or;
function Un() {
  return Or || (Or = 1, process.env.NODE_ENV !== "production" && function() {
    var e = rt, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), u = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), U = Symbol.iterator, S = "@@iterator";
    function P(i) {
      if (i === null || typeof i != "object")
        return null;
      var d = U && i[U] || i[S];
      return typeof d == "function" ? d : null;
    }
    var T = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(i) {
      {
        for (var d = arguments.length, f = new Array(d > 1 ? d - 1 : 0), m = 1; m < d; m++)
          f[m - 1] = arguments[m];
        D("error", i, f);
      }
    }
    function D(i, d, f) {
      {
        var m = T.ReactDebugCurrentFrame, y = m.getStackAddendum();
        y !== "" && (d += "%s", f = f.concat([y]));
        var v = f.map(function(w) {
          return String(w);
        });
        v.unshift("Warning: " + d), Function.prototype.apply.call(console[i], console, v);
      }
    }
    var W = !1, B = !1, te = !1, $ = !1, ge = !1, ye;
    ye = Symbol.for("react.module.reference");
    function K(i) {
      return !!(typeof i == "string" || typeof i == "function" || i === n || i === o || ge || i === s || i === l || i === p || $ || i === O || W || B || te || typeof i == "object" && i !== null && (i.$$typeof === k || i.$$typeof === g || i.$$typeof === c || i.$$typeof === u || i.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      i.$$typeof === ye || i.getModuleId !== void 0));
    }
    function re(i, d, f) {
      var m = i.displayName;
      if (m)
        return m;
      var y = d.displayName || d.name || "";
      return y !== "" ? f + "(" + y + ")" : f;
    }
    function ce(i) {
      return i.displayName || "Context";
    }
    function N(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case l:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case u:
            var d = i;
            return ce(d) + ".Consumer";
          case c:
            var f = i;
            return ce(f._context) + ".Provider";
          case h:
            return re(i, i.render, "ForwardRef");
          case g:
            var m = i.displayName || null;
            return m !== null ? m : N(i.type) || "Memo";
          case k: {
            var y = i, v = y._payload, w = y._init;
            try {
              return N(w(v));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, q = 0, L, H, de, he, Se, fe, E;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function ke() {
      {
        if (q === 0) {
          L = console.log, H = console.info, de = console.warn, he = console.error, Se = console.group, fe = console.groupCollapsed, E = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        q++;
      }
    }
    function nt() {
      {
        if (q--, q === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, i, {
              value: L
            }),
            info: M({}, i, {
              value: H
            }),
            warn: M({}, i, {
              value: de
            }),
            error: M({}, i, {
              value: he
            }),
            group: M({}, i, {
              value: Se
            }),
            groupCollapsed: M({}, i, {
              value: fe
            }),
            groupEnd: M({}, i, {
              value: E
            })
          });
        }
        q < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = T.ReactCurrentDispatcher, we;
    function ve(i, d, f) {
      {
        if (we === void 0)
          try {
            throw Error();
          } catch (y) {
            var m = y.stack.trim().match(/\n( *(at )?)/);
            we = m && m[1] || "";
          }
        return `
` + we + i;
      }
    }
    var Y = !1, pe;
    {
      var Fe = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new Fe();
    }
    function Ie(i, d) {
      if (!i || Y)
        return "";
      {
        var f = pe.get(i);
        if (f !== void 0)
          return f;
      }
      var m;
      Y = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var v;
      v = Oe.current, Oe.current = null, ke();
      try {
        if (d) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (me) {
              m = me;
            }
            Reflect.construct(i, [], w);
          } else {
            try {
              w.call();
            } catch (me) {
              m = me;
            }
            i.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (me) {
            m = me;
          }
          i();
        }
      } catch (me) {
        if (me && m && typeof me.stack == "string") {
          for (var b = me.stack.split(`
`), x = m.stack.split(`
`), I = b.length - 1, A = x.length - 1; I >= 1 && A >= 0 && b[I] !== x[A]; )
            A--;
          for (; I >= 1 && A >= 0; I--, A--)
            if (b[I] !== x[A]) {
              if (I !== 1 || A !== 1)
                do
                  if (I--, A--, A < 0 || b[I] !== x[A]) {
                    var X = `
` + b[I].replace(" at new ", " at ");
                    return i.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", i.displayName)), typeof i == "function" && pe.set(i, X), X;
                  }
                while (I >= 1 && A >= 0);
              break;
            }
        }
      } finally {
        Y = !1, Oe.current = v, nt(), Error.prepareStackTrace = y;
      }
      var qe = i ? i.displayName || i.name : "", oe = qe ? ve(qe) : "";
      return typeof i == "function" && pe.set(i, oe), oe;
    }
    function xe(i, d, f) {
      return Ie(i, !1);
    }
    function We(i) {
      var d = i.prototype;
      return !!(d && d.isReactComponent);
    }
    function ue(i, d, f) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return Ie(i, We(i));
      if (typeof i == "string")
        return ve(i);
      switch (i) {
        case l:
          return ve("Suspense");
        case p:
          return ve("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case h:
            return xe(i.render);
          case g:
            return ue(i.type, d, f);
          case k: {
            var m = i, y = m._payload, v = m._init;
            try {
              return ue(v(y), d, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, He = {}, se = T.ReactDebugCurrentFrame;
    function ie(i) {
      if (i) {
        var d = i._owner, f = ue(i.type, i._source, d ? d.type : null);
        se.setExtraStackFrame(f);
      } else
        se.setExtraStackFrame(null);
    }
    function st(i, d, f, m, y) {
      {
        var v = Function.call.bind(Z);
        for (var w in i)
          if (v(i, w)) {
            var b = void 0;
            try {
              if (typeof i[w] != "function") {
                var x = Error((m || "React class") + ": " + f + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw x.name = "Invariant Violation", x;
              }
              b = i[w](d, w, m, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I) {
              b = I;
            }
            b && !(b instanceof Error) && (ie(y), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", f, w, typeof b), ie(null)), b instanceof Error && !(b.message in He) && (He[b.message] = !0, ie(y), R("Failed %s type: %s", f, b.message), ie(null));
          }
      }
    }
    var it = Array.isArray;
    function Ee(i) {
      return it(i);
    }
    function Ge(i) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, f = d && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return f;
      }
    }
    function Qe(i) {
      try {
        return Ce(i), !1;
      } catch {
        return !0;
      }
    }
    function Ce(i) {
      return "" + i;
    }
    function _e(i) {
      if (Qe(i))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ge(i)), Ce(i);
    }
    var G = T.ReactCurrentOwner, Te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Je, be;
    be = {};
    function Xe(i) {
      if (Z.call(i, "ref")) {
        var d = Object.getOwnPropertyDescriptor(i, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return i.ref !== void 0;
    }
    function gt(i) {
      if (Z.call(i, "key")) {
        var d = Object.getOwnPropertyDescriptor(i, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return i.key !== void 0;
    }
    function _t(i, d) {
      if (typeof i.ref == "string" && G.current && d && G.current.stateNode !== d) {
        var f = N(G.current.type);
        be[f] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', N(G.current.type), i.ref), be[f] = !0);
      }
    }
    function mt(i, d) {
      {
        var f = function() {
          Ne || (Ne = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        f.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function wt(i, d) {
      {
        var f = function() {
          Je || (Je = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        f.isReactWarning = !0, Object.defineProperty(i, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var vt = function(i, d, f, m, y, v, w) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: i,
        key: d,
        ref: f,
        props: w,
        // Record the component responsible for creating this element.
        _owner: v
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function yt(i, d, f, m, y) {
      {
        var v, w = {}, b = null, x = null;
        f !== void 0 && (_e(f), b = "" + f), gt(d) && (_e(d.key), b = "" + d.key), Xe(d) && (x = d.ref, _t(d, y));
        for (v in d)
          Z.call(d, v) && !Te.hasOwnProperty(v) && (w[v] = d[v]);
        if (i && i.defaultProps) {
          var I = i.defaultProps;
          for (v in I)
            w[v] === void 0 && (w[v] = I[v]);
        }
        if (b || x) {
          var A = typeof i == "function" ? i.displayName || i.name || "Unknown" : i;
          b && mt(w, A), x && wt(w, A);
        }
        return vt(i, b, x, y, m, G.current, w);
      }
    }
    var Pe = T.ReactCurrentOwner, ze = T.ReactDebugCurrentFrame;
    function le(i) {
      if (i) {
        var d = i._owner, f = ue(i.type, i._source, d ? d.type : null);
        ze.setExtraStackFrame(f);
      } else
        ze.setExtraStackFrame(null);
    }
    var Le;
    Le = !1;
    function Me(i) {
      return typeof i == "object" && i !== null && i.$$typeof === t;
    }
    function Ke() {
      {
        if (Pe.current) {
          var i = N(Pe.current.type);
          if (i)
            return `

Check the render method of \`` + i + "`.";
        }
        return "";
      }
    }
    function ot(i) {
      return "";
    }
    var Ze = {};
    function bt(i) {
      {
        var d = Ke();
        if (!d) {
          var f = typeof i == "string" ? i : i.displayName || i.name;
          f && (d = `

Check the top-level render call using <` + f + ">.");
        }
        return d;
      }
    }
    function Q(i, d) {
      {
        if (!i._store || i._store.validated || i.key != null)
          return;
        i._store.validated = !0;
        var f = bt(d);
        if (Ze[f])
          return;
        Ze[f] = !0;
        var m = "";
        i && i._owner && i._owner !== Pe.current && (m = " It was passed a child from " + N(i._owner.type) + "."), le(i), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, m), le(null);
      }
    }
    function _(i, d) {
      {
        if (typeof i != "object")
          return;
        if (Ee(i))
          for (var f = 0; f < i.length; f++) {
            var m = i[f];
            Me(m) && Q(m, d);
          }
        else if (Me(i))
          i._store && (i._store.validated = !0);
        else if (i) {
          var y = P(i);
          if (typeof y == "function" && y !== i.entries)
            for (var v = y.call(i), w; !(w = v.next()).done; )
              Me(w.value) && Q(w.value, d);
        }
      }
    }
    function ee(i) {
      {
        var d = i.type;
        if (d == null || typeof d == "string")
          return;
        var f;
        if (typeof d == "function")
          f = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === g))
          f = d.propTypes;
        else
          return;
        if (f) {
          var m = N(d);
          st(f, i.props, "prop", m, i);
        } else if (d.PropTypes !== void 0 && !Le) {
          Le = !0;
          var y = N(d);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", y || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ve(i) {
      {
        for (var d = Object.keys(i.props), f = 0; f < d.length; f++) {
          var m = d[f];
          if (m !== "children" && m !== "key") {
            le(i), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), le(null);
            break;
          }
        }
        i.ref !== null && (le(i), R("Invalid attribute `ref` supplied to `React.Fragment`."), le(null));
      }
    }
    var St = {};
    function At(i, d, f, m, y, v) {
      {
        var w = K(i);
        if (!w) {
          var b = "";
          (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var x = ot();
          x ? b += x : b += Ke();
          var I;
          i === null ? I = "null" : Ee(i) ? I = "array" : i !== void 0 && i.$$typeof === t ? (I = "<" + (N(i.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : I = typeof i, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, b);
        }
        var A = yt(i, d, f, y, v);
        if (A == null)
          return A;
        if (w) {
          var X = d.children;
          if (X !== void 0)
            if (m)
              if (Ee(X)) {
                for (var qe = 0; qe < X.length; qe++)
                  _(X[qe], i);
                Object.freeze && Object.freeze(X);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _(X, i);
        }
        if (Z.call(d, "key")) {
          var oe = N(i), me = Object.keys(d).filter(function(In) {
            return In !== "key";
          }), zt = me.length > 0 ? "{key: someKey, " + me.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!St[oe + zt]) {
            var On = me.length > 0 ? "{" + me.join(": ..., ") + ": ...}" : "{}";
            R(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, zt, oe, On, oe), St[oe + zt] = !0;
          }
        }
        return i === n ? Ve(A) : ee(A), A;
      }
    }
    function Wt(i, d, f) {
      return At(i, d, f, !0);
    }
    function Ht(i, d, f) {
      return At(i, d, f, !1);
    }
    var Jt = Ht, a = Wt;
    Et.Fragment = n, Et.jsx = Jt, Et.jsxs = a;
  }()), Et;
}
process.env.NODE_ENV === "production" ? Zt.exports = jn() : Zt.exports = Un();
var ft = Zt.exports;
const Yr = () => {
}, fr = dr({
  isLoading: !1,
  isAuthenticated: !1,
  logout: Yr
}), Ji = () => Vr(fr);
let Gr = Yr;
function Qr() {
  Gr();
}
const Xr = "/oauth/logout", Nn = "/refresh", Ir = 15 * 60 * 1e3, Ln = 30 * 60;
let Ct = 0;
function Zr() {
  Ct > 0 && (window.clearTimeout(Ct), Ct = 0);
}
function Mn() {
  let e = 0;
  const t = () => {
    e = Date.now() + Ln * 1e3;
  };
  t(), document.addEventListener("keydown", t, !0), document.addEventListener("mousemove", t, !0), function r() {
    window.setTimeout(async () => {
      Date.now() > e ? (Qr(), await fetch(Xr, {
        method: "GET",
        headers: new Headers({ Accept: "*/*" }),
        credentials: "same-origin"
      }), Zr()) : r();
    }, e - Date.now());
  }();
}
function pr() {
  Zr(), console.info(
    `[${(/* @__PURE__ */ new Date()).toLocaleString()}] Init refresh timeout in ${Ir / 1e3} seconds`
  ), Ct = window.setTimeout(async () => {
    Ct = 0, console.info(`[${(/* @__PURE__ */ new Date()).toLocaleString()}] Refreshing token`), await fetch(Nn, {
      method: "GET",
      headers: new Headers({ Accept: "*/*" }),
      credentials: "same-origin"
    }), console.info(`[${(/* @__PURE__ */ new Date()).toLocaleString()}] Token refreshed`), pr();
  }, Ir);
}
function qn() {
  console.info(`[${(/* @__PURE__ */ new Date()).toLocaleString()}] Request sent`), pr();
}
const zi = () => new Br(
  (e, t) => new An((r) => {
    let n;
    try {
      n = t(e).subscribe({
        next: (s) => {
          qn(), r.next(s);
        },
        error: (s) => {
          r.error(s);
        },
        complete: r.complete.bind(r)
      });
    } catch (s) {
      r.error(s);
    }
    return () => {
      n && n.unsubscribe();
    };
  })
), Dn = ({ children: e }) => {
  const [t, r] = hr(!0);
  z(() => {
    Gr = () => r(!1), Mn(), pr();
  }, []);
  const n = Pt(
    () => ({
      isLoading: !1,
      isAuthenticated: t,
      logout: async () => {
        await fetch(Xr, {
          method: "GET",
          headers: new Headers({ Accept: "*/*" }),
          credentials: "same-origin"
        });
      }
    }),
    [t]
  );
  return /* @__PURE__ */ ft.jsx(fr.Provider, { value: n, children: e });
};
var $n = Object.defineProperty, Fn = (e, t, r) => t in e ? $n(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, F = (e, t, r) => (Fn(e, typeof t != "symbol" ? t + "" : t, r), r), er = { exports: {} }, Tt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xr;
function Wn() {
  if (xr)
    return Tt;
  xr = 1;
  var e = rt, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(u, h, l) {
    var p, g = {}, k = null, O = null;
    l !== void 0 && (k = "" + l), h.key !== void 0 && (k = "" + h.key), h.ref !== void 0 && (O = h.ref);
    for (p in h)
      n.call(h, p) && !o.hasOwnProperty(p) && (g[p] = h[p]);
    if (u && u.defaultProps)
      for (p in h = u.defaultProps, h)
        g[p] === void 0 && (g[p] = h[p]);
    return { $$typeof: t, type: u, key: k, ref: O, props: g, _owner: s.current };
  }
  return Tt.Fragment = r, Tt.jsx = c, Tt.jsxs = c, Tt;
}
var jt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cr;
function Hn() {
  return Cr || (Cr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = rt, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), u = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), U = Symbol.iterator, S = "@@iterator";
    function P(a) {
      if (a === null || typeof a != "object")
        return null;
      var i = U && a[U] || a[S];
      return typeof i == "function" ? i : null;
    }
    var T = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(a) {
      {
        for (var i = arguments.length, d = new Array(i > 1 ? i - 1 : 0), f = 1; f < i; f++)
          d[f - 1] = arguments[f];
        D("error", a, d);
      }
    }
    function D(a, i, d) {
      {
        var f = T.ReactDebugCurrentFrame, m = f.getStackAddendum();
        m !== "" && (i += "%s", d = d.concat([m]));
        var y = d.map(function(v) {
          return String(v);
        });
        y.unshift("Warning: " + i), Function.prototype.apply.call(console[a], console, y);
      }
    }
    var W = !1, B = !1, te = !1, $ = !1, ge = !1, ye;
    ye = Symbol.for("react.module.reference");
    function K(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === o || ge || a === s || a === l || a === p || $ || a === O || W || B || te || typeof a == "object" && a !== null && (a.$$typeof === k || a.$$typeof === g || a.$$typeof === c || a.$$typeof === u || a.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === ye || a.getModuleId !== void 0));
    }
    function re(a, i, d) {
      var f = a.displayName;
      if (f)
        return f;
      var m = i.displayName || i.name || "";
      return m !== "" ? d + "(" + m + ")" : d;
    }
    function ce(a) {
      return a.displayName || "Context";
    }
    function N(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case l:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case u:
            var i = a;
            return ce(i) + ".Consumer";
          case c:
            var d = a;
            return ce(d._context) + ".Provider";
          case h:
            return re(a, a.render, "ForwardRef");
          case g:
            var f = a.displayName || null;
            return f !== null ? f : N(a.type) || "Memo";
          case k: {
            var m = a, y = m._payload, v = m._init;
            try {
              return N(v(y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, q = 0, L, H, de, he, Se, fe, E;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function ke() {
      {
        if (q === 0) {
          L = console.log, H = console.info, de = console.warn, he = console.error, Se = console.group, fe = console.groupCollapsed, E = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        q++;
      }
    }
    function nt() {
      {
        if (q--, q === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, a, {
              value: L
            }),
            info: M({}, a, {
              value: H
            }),
            warn: M({}, a, {
              value: de
            }),
            error: M({}, a, {
              value: he
            }),
            group: M({}, a, {
              value: Se
            }),
            groupCollapsed: M({}, a, {
              value: fe
            }),
            groupEnd: M({}, a, {
              value: E
            })
          });
        }
        q < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = T.ReactCurrentDispatcher, we;
    function ve(a, i, d) {
      {
        if (we === void 0)
          try {
            throw Error();
          } catch (m) {
            var f = m.stack.trim().match(/\n( *(at )?)/);
            we = f && f[1] || "";
          }
        return `
` + we + a;
      }
    }
    var Y = !1, pe;
    {
      var Fe = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new Fe();
    }
    function Ie(a, i) {
      if (!a || Y)
        return "";
      {
        var d = pe.get(a);
        if (d !== void 0)
          return d;
      }
      var f;
      Y = !0;
      var m = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var y;
      y = Oe.current, Oe.current = null, ke();
      try {
        if (i) {
          var v = function() {
            throw Error();
          };
          if (Object.defineProperty(v.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(v, []);
            } catch (oe) {
              f = oe;
            }
            Reflect.construct(a, [], v);
          } else {
            try {
              v.call();
            } catch (oe) {
              f = oe;
            }
            a.call(v.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            f = oe;
          }
          a();
        }
      } catch (oe) {
        if (oe && f && typeof oe.stack == "string") {
          for (var w = oe.stack.split(`
`), b = f.stack.split(`
`), x = w.length - 1, I = b.length - 1; x >= 1 && I >= 0 && w[x] !== b[I]; )
            I--;
          for (; x >= 1 && I >= 0; x--, I--)
            if (w[x] !== b[I]) {
              if (x !== 1 || I !== 1)
                do
                  if (x--, I--, I < 0 || w[x] !== b[I]) {
                    var A = `
` + w[x].replace(" at new ", " at ");
                    return a.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", a.displayName)), typeof a == "function" && pe.set(a, A), A;
                  }
                while (x >= 1 && I >= 0);
              break;
            }
        }
      } finally {
        Y = !1, Oe.current = y, nt(), Error.prepareStackTrace = m;
      }
      var X = a ? a.displayName || a.name : "", qe = X ? ve(X) : "";
      return typeof a == "function" && pe.set(a, qe), qe;
    }
    function xe(a, i, d) {
      return Ie(a, !1);
    }
    function We(a) {
      var i = a.prototype;
      return !!(i && i.isReactComponent);
    }
    function ue(a, i, d) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return Ie(a, We(a));
      if (typeof a == "string")
        return ve(a);
      switch (a) {
        case l:
          return ve("Suspense");
        case p:
          return ve("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case h:
            return xe(a.render);
          case g:
            return ue(a.type, i, d);
          case k: {
            var f = a, m = f._payload, y = f._init;
            try {
              return ue(y(m), i, d);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, He = {}, se = T.ReactDebugCurrentFrame;
    function ie(a) {
      if (a) {
        var i = a._owner, d = ue(a.type, a._source, i ? i.type : null);
        se.setExtraStackFrame(d);
      } else
        se.setExtraStackFrame(null);
    }
    function st(a, i, d, f, m) {
      {
        var y = Function.call.bind(Z);
        for (var v in a)
          if (y(a, v)) {
            var w = void 0;
            try {
              if (typeof a[v] != "function") {
                var b = Error((f || "React class") + ": " + d + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw b.name = "Invariant Violation", b;
              }
              w = a[v](i, v, f, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              w = x;
            }
            w && !(w instanceof Error) && (ie(m), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", d, v, typeof w), ie(null)), w instanceof Error && !(w.message in He) && (He[w.message] = !0, ie(m), R("Failed %s type: %s", d, w.message), ie(null));
          }
      }
    }
    var it = Array.isArray;
    function Ee(a) {
      return it(a);
    }
    function Ge(a) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, d = i && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return d;
      }
    }
    function Qe(a) {
      try {
        return Ce(a), !1;
      } catch {
        return !0;
      }
    }
    function Ce(a) {
      return "" + a;
    }
    function _e(a) {
      if (Qe(a))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ge(a)), Ce(a);
    }
    var G = T.ReactCurrentOwner, Te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Je, be;
    be = {};
    function Xe(a) {
      if (Z.call(a, "ref")) {
        var i = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function gt(a) {
      if (Z.call(a, "key")) {
        var i = Object.getOwnPropertyDescriptor(a, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function _t(a, i) {
      if (typeof a.ref == "string" && G.current && i && G.current.stateNode !== i) {
        var d = N(G.current.type);
        be[d] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', N(G.current.type), a.ref), be[d] = !0);
      }
    }
    function mt(a, i) {
      {
        var d = function() {
          Ne || (Ne = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        d.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: d,
          configurable: !0
        });
      }
    }
    function wt(a, i) {
      {
        var d = function() {
          Je || (Je = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        d.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: d,
          configurable: !0
        });
      }
    }
    var vt = function(a, i, d, f, m, y, v) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: a,
        key: i,
        ref: d,
        props: v,
        // Record the component responsible for creating this element.
        _owner: y
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function yt(a, i, d, f, m) {
      {
        var y, v = {}, w = null, b = null;
        d !== void 0 && (_e(d), w = "" + d), gt(i) && (_e(i.key), w = "" + i.key), Xe(i) && (b = i.ref, _t(i, m));
        for (y in i)
          Z.call(i, y) && !Te.hasOwnProperty(y) && (v[y] = i[y]);
        if (a && a.defaultProps) {
          var x = a.defaultProps;
          for (y in x)
            v[y] === void 0 && (v[y] = x[y]);
        }
        if (w || b) {
          var I = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          w && mt(v, I), b && wt(v, I);
        }
        return vt(a, w, b, m, f, G.current, v);
      }
    }
    var Pe = T.ReactCurrentOwner, ze = T.ReactDebugCurrentFrame;
    function le(a) {
      if (a) {
        var i = a._owner, d = ue(a.type, a._source, i ? i.type : null);
        ze.setExtraStackFrame(d);
      } else
        ze.setExtraStackFrame(null);
    }
    var Le;
    Le = !1;
    function Me(a) {
      return typeof a == "object" && a !== null && a.$$typeof === t;
    }
    function Ke() {
      {
        if (Pe.current) {
          var a = N(Pe.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function ot(a) {
      return "";
    }
    var Ze = {};
    function bt(a) {
      {
        var i = Ke();
        if (!i) {
          var d = typeof a == "string" ? a : a.displayName || a.name;
          d && (i = `

Check the top-level render call using <` + d + ">.");
        }
        return i;
      }
    }
    function Q(a, i) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var d = bt(i);
        if (Ze[d])
          return;
        Ze[d] = !0;
        var f = "";
        a && a._owner && a._owner !== Pe.current && (f = " It was passed a child from " + N(a._owner.type) + "."), le(a), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, f), le(null);
      }
    }
    function _(a, i) {
      {
        if (typeof a != "object")
          return;
        if (Ee(a))
          for (var d = 0; d < a.length; d++) {
            var f = a[d];
            Me(f) && Q(f, i);
          }
        else if (Me(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var m = P(a);
          if (typeof m == "function" && m !== a.entries)
            for (var y = m.call(a), v; !(v = y.next()).done; )
              Me(v.value) && Q(v.value, i);
        }
      }
    }
    function ee(a) {
      {
        var i = a.type;
        if (i == null || typeof i == "string")
          return;
        var d;
        if (typeof i == "function")
          d = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === g))
          d = i.propTypes;
        else
          return;
        if (d) {
          var f = N(i);
          st(d, a.props, "prop", f, a);
        } else if (i.PropTypes !== void 0 && !Le) {
          Le = !0;
          var m = N(i);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ve(a) {
      {
        for (var i = Object.keys(a.props), d = 0; d < i.length; d++) {
          var f = i[d];
          if (f !== "children" && f !== "key") {
            le(a), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), le(null);
            break;
          }
        }
        a.ref !== null && (le(a), R("Invalid attribute `ref` supplied to `React.Fragment`."), le(null));
      }
    }
    function St(a, i, d, f, m, y) {
      {
        var v = K(a);
        if (!v) {
          var w = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var b = ot();
          b ? w += b : w += Ke();
          var x;
          a === null ? x = "null" : Ee(a) ? x = "array" : a !== void 0 && a.$$typeof === t ? (x = "<" + (N(a.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : x = typeof a, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, w);
        }
        var I = yt(a, i, d, m, y);
        if (I == null)
          return I;
        if (v) {
          var A = i.children;
          if (A !== void 0)
            if (f)
              if (Ee(A)) {
                for (var X = 0; X < A.length; X++)
                  _(A[X], a);
                Object.freeze && Object.freeze(A);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _(A, a);
        }
        return a === n ? Ve(I) : ee(I), I;
      }
    }
    function At(a, i, d) {
      return St(a, i, d, !0);
    }
    function Wt(a, i, d) {
      return St(a, i, d, !1);
    }
    var Ht = Wt, Jt = At;
    jt.Fragment = n, jt.jsx = Ht, jt.jsxs = Jt;
  }()), jt;
}
process.env.NODE_ENV === "production" ? er.exports = Wn() : er.exports = Hn();
var tr = er.exports, Jn = Object.create, en = Object.defineProperty, zn = Object.getOwnPropertyDescriptor, Kn = Object.getOwnPropertyNames, Vn = Object.getPrototypeOf, Bn = Object.prototype.hasOwnProperty, Yn = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Gn = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let s of Kn(t))
      !Bn.call(e, s) && s !== r && en(e, s, { get: () => t[s], enumerable: !(n = zn(t, s)) || n.enumerable });
  return e;
}, Qn = (e, t, r) => (r = e != null ? Jn(Vn(e)) : {}, Gn(!e || !e.__esModule ? en(r, "default", { value: e, enumerable: !0 }) : r, e)), Xn = Yn((e, t) => {
  (function(r, n) {
    typeof e == "object" && typeof t < "u" ? n(e) : typeof define == "function" && define.amd ? define(["exports"], n) : (r = typeof globalThis < "u" ? globalThis : r || self, n(r.fastUniqueNumbers = {}));
  })(e, function(r) {
    var n = function(O) {
      return function(U) {
        var S = O(U);
        return U.add(S), S;
      };
    }, s = function(O) {
      return function(U, S) {
        return O.set(U, S), S;
      };
    }, o = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, c = 536870912, u = c * 2, h = function(O, U) {
      return function(S) {
        var P = U.get(S), T = P === void 0 ? S.size : P < u ? P + 1 : 0;
        if (!S.has(T))
          return O(S, T);
        if (S.size < c) {
          for (; S.has(T); )
            T = Math.floor(Math.random() * u);
          return O(S, T);
        }
        if (S.size > o)
          throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
        for (; S.has(T); )
          T = Math.floor(Math.random() * o);
        return O(S, T);
      };
    }, l = /* @__PURE__ */ new WeakMap(), p = s(l), g = h(p, l), k = n(g);
    r.addUniqueNumber = k, r.generateUniqueNumber = g;
  });
});
Qn(Xn());
var De = (typeof window > "u" ? "undefined" : typeof window) == "object", Re = { setTimeout: De ? setTimeout.bind(window) : setTimeout, clearTimeout: De ? clearTimeout.bind(window) : clearTimeout, setInterval: De ? setInterval.bind(window) : setInterval, clearInterval: De ? clearInterval.bind(window) : clearInterval };
function Zn(e) {
  Re.setTimeout = e.setTimeout, Re.clearTimeout = e.clearTimeout, Re.setInterval = e.setInterval, Re.clearInterval = e.clearInterval;
}
var at = {}, es = class {
  constructor(e) {
    F(this, "name"), F(this, "closed", !1), F(this, "mc", new MessageChannel()), this.name = e, at[e] = at[e] || [], at[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
  }
  onStorage(e) {
    if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null)
      return;
    let t = JSON.parse(e.newValue);
    this.mc.port2.postMessage(t);
  }
  postMessage(e) {
    if (this.closed)
      throw new Error("InvalidStateError");
    let t = JSON.stringify(e), r = `${this.name}:${String(Date.now())}${String(Math.random())}`;
    window.localStorage.setItem(r, t), Re.setTimeout(() => {
      window.localStorage.removeItem(r);
    }, 500), at[this.name].forEach((n) => {
      n !== this && n.mc.port2.postMessage(JSON.parse(t));
    });
  }
  close() {
    if (this.closed)
      return;
    this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
    let e = at[this.name].indexOf(this);
    at[this.name].splice(e, 1);
  }
  get onmessage() {
    return this.mc.port1.onmessage;
  }
  set onmessage(e) {
    this.mc.port1.onmessage = e;
  }
  get onmessageerror() {
    return this.mc.port1.onmessageerror;
  }
  set onmessageerror(e) {
    this.mc.port1.onmessageerror = e;
  }
  addEventListener(e, t) {
    return this.mc.port1.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    return this.mc.port1.removeEventListener(e, t);
  }
  dispatchEvent(e) {
    return this.mc.port1.dispatchEvent(e);
  }
}, ts = typeof window > "u" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : es;
function rs(e = 0) {
  return new Promise((t) => Re.setTimeout(t, e));
}
function tn() {
  return Math.random().toString(36).substring(2);
}
var ns = class {
  constructor(e, t) {
    F(this, "options"), F(this, "channel"), F(this, "token", tn()), F(this, "isLeader", !1), F(this, "isDead", !1), F(this, "isApplying", !1), F(this, "reApply", !1), F(this, "intervals", []), F(this, "listeners", []), F(this, "deferred"), this.channel = e, this.options = t, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
  }
  async apply() {
    if (this.isLeader || this.isDead)
      return !1;
    if (this.isApplying)
      return this.reApply = !0, !1;
    this.isApplying = !0;
    let e = !1, t = (r) => {
      let { token: n, action: s } = r.data;
      n !== this.token && (s === 0 && n > this.token && (e = !0), s === 1 && (e = !0));
    };
    this.channel.addEventListener("message", t);
    try {
      return this.sendAction(0), await rs(this.options.responseTime), this.channel.removeEventListener("message", t), this.isApplying = !1, e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0);
    } catch {
      return !1;
    }
  }
  awaitLeadership() {
    if (this.isLeader)
      return Promise.resolve();
    let e = !1, t = null;
    return new Promise((r) => {
      let n = () => {
        if (e)
          return;
        e = !0;
        try {
          Re.clearInterval(t);
        } catch {
        }
        let o = this.intervals.indexOf(t);
        o >= 0 && this.intervals.splice(o, 1), this.channel.removeEventListener("message", s), r();
      };
      t = Re.setInterval(() => {
        this.apply().then(() => {
          this.isLeader && n();
        });
      }, this.options.fallbackInterval), this.intervals.push(t);
      let s = (o) => {
        let { action: c } = o.data;
        c === 2 && this.apply().then(() => {
          this.isLeader && n();
        });
      };
      this.channel.addEventListener("message", s);
    });
  }
  sendAction(e) {
    this.channel.postMessage({ action: e, token: this.token });
  }
  assumeLead() {
    this.isLeader = !0;
    let e = (t) => {
      let { action: r } = t.data;
      r === 0 && this.sendAction(1);
    };
    return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(1);
  }
  waitForLeadership() {
    return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
  }
  close() {
    if (!this.isDead) {
      this.isDead = !0, this.isLeader = !1, this.sendAction(2);
      try {
        this.listeners.forEach((e) => this.channel.removeEventListener("message", e)), this.intervals.forEach((e) => Re.clearInterval(e));
      } catch {
      }
    }
  }
}, ss = class {
  constructor(e) {
    F(this, "channel"), F(this, "options"), F(this, "elector"), F(this, "token", tn()), F(this, "registry", /* @__PURE__ */ new Map()), F(this, "allIdle", !1), F(this, "isLastActive", !1);
    let { channelName: t } = e;
    if (this.options = e, this.channel = new ts(t), this.registry.set(this.token, 1), e.leaderElection) {
      let r = { fallbackInterval: 2e3, responseTime: 100 };
      this.elector = new ns(this.channel, r), this.elector.waitForLeadership();
    }
    this.channel.addEventListener("message", (r) => {
      let { action: n, token: s, data: o } = r.data;
      switch (n) {
        case 3:
          this.registry.set(s, 2);
          break;
        case 4:
          this.registry.delete(s);
          break;
        case 5:
          this.idle(s);
          break;
        case 6:
          this.active(s);
          break;
        case 7:
          this.prompt(s);
          break;
        case 8:
          this.start(s);
          break;
        case 9:
          this.reset(s);
          break;
        case 10:
          this.activate(s);
          break;
        case 11:
          this.pause(s);
          break;
        case 12:
          this.resume(s);
          break;
        case 13:
          this.options.onMessage(o);
          break;
      }
    }), this.send(3);
  }
  get isLeader() {
    if (!this.elector)
      throw new Error('❌ Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
    return this.elector.isLeader;
  }
  prompt(e = this.token) {
    this.registry.set(e, 0);
    let t = [...this.registry.values()].every((r) => r === 0);
    e === this.token && this.send(7), t && this.options.onPrompt();
  }
  idle(e = this.token) {
    this.registry.set(e, 2);
    let t = [...this.registry.values()].every((r) => r === 2);
    e === this.token && this.send(5), !this.allIdle && t && (this.allIdle = !0, this.options.onIdle());
  }
  active(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1);
    let t = [...this.registry.values()].some((r) => r === 1);
    e === this.token && this.send(6), t && this.options.onActive(), this.isLastActive = e === this.token;
  }
  start(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(8) : this.options.start(!0), this.isLastActive = e === this.token;
  }
  reset(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(9) : this.options.reset(!0), this.isLastActive = e === this.token;
  }
  activate(e = this.token) {
    this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(10) : this.options.activate(!0), this.isLastActive = e === this.token;
  }
  pause(e = this.token) {
    e === this.token ? this.send(11) : this.options.pause(!0);
  }
  resume(e = this.token) {
    e === this.token ? this.send(12) : this.options.resume(!0);
  }
  message(e) {
    try {
      this.channel.postMessage({ action: 13, token: this.token, data: e });
    } catch {
    }
  }
  send(e) {
    try {
      this.channel.postMessage({ action: e, token: this.token });
    } catch {
    }
  }
  close() {
    this.options.leaderElection && this.elector.close(), this.send(4), this.channel.close();
  }
}, is = De ? document : null, os = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange", "focus"];
function as(e, t) {
  let r;
  function n(...s) {
    r && clearTimeout(r), r = setTimeout(() => {
      e(...s), r = null;
    }, t);
  }
  return n.cancel = function() {
    clearTimeout(r);
  }, n;
}
function Vt(e, t) {
  let r = 0;
  return function(...n) {
    let s = (/* @__PURE__ */ new Date()).getTime();
    if (!(s - r < t))
      return r = s, e(...n);
  };
}
var V = () => Date.now(), ct = 2147483647;
function cs({ timeout: e = 1e3 * 60 * 20, promptTimeout: t = 0, promptBeforeIdle: r = 0, element: n = is, events: s = os, timers: o = void 0, immediateEvents: c = [], onPresenceChange: u = () => {
}, onPrompt: h = () => {
}, onIdle: l = () => {
}, onActive: p = () => {
}, onAction: g = () => {
}, onMessage: k = () => {
}, debounce: O = 0, throttle: U = 0, eventsThrottle: S = 200, startOnMount: P = !0, startManually: T = !1, stopOnIdle: R = !1, crossTab: D = !1, name: W = "idle-timer", syncTimers: B = 0, leaderElection: te = !1, disabled: $ = !1 } = {}) {
  let ge = j(V()), ye = j(V()), K = j(null), re = j(null), ce = j(0), N = j(0), M = j(0), q = j(0), L = j(!1), H = j(!1), de = j(!1), he = j(!0), Se = j(!1), fe = j(null), E = j(null), ne = j(e), ke = j(0);
  z(() => {
    if (t && console.warn("⚠️ IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), r && t)
      throw new Error("❌ Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
    if (e >= ct)
      throw new Error(`❌ The value for the timeout property must fit in a 32 bit signed integer, ${ct}.`);
    if (t >= ct)
      throw new Error(`❌ The value for the promptTimeout property must fit in a 32 bit signed integer, ${ct}.`);
    if (r >= ct)
      throw new Error(`❌ The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ${ct}.`);
    if (r >= e)
      throw new Error(`❌ The value for the promptBeforeIdle property must be less than the timeout property, ${e}.`);
    if (r ? (ne.current = e - r, ke.current = r) : (ne.current = e, ke.current = t), !he.current) {
      if (T || $)
        return;
      L.current && (xe.current(null, Q), E.current && E.current.active()), Te();
    }
  }, [e, t, r, T, $]);
  let nt = j(R);
  z(() => {
    nt.current = R;
  }, [R]);
  let Oe = j(c), we = j(n), ve = j([...(/* @__PURE__ */ new Set([...s, ...c])).values()]), Y = j($);
  z(() => {
    Y.current = $, !he.current && ($ ? be() : T || Te());
  }, [$]);
  let pe = j(u);
  z(() => {
    pe.current = u;
  }, [u]);
  let Fe = j(h);
  z(() => {
    Fe.current = h;
  }, [h]);
  let Ie = j(l);
  z(() => {
    Ie.current = l;
  }, [l]);
  let xe = j(p);
  z(() => {
    xe.current = p;
  }, [p]);
  let We = j(g);
  z(() => {
    We.current = g;
  }, [g]);
  let ue = j(k);
  z(() => {
    ue.current = k;
  }, [k]);
  let Z = Pt(() => {
    let _ = (ee, Ve) => We.current(ee, Ve);
    return O > 0 ? as(_, O) : U > 0 ? Vt(_, U) : _;
  }, [U, O]), He = j();
  z(() => {
    D && B && (He.current = Vt(() => {
      E.current.active();
    }, B));
  }, [D, B]);
  let se = () => {
    fe.current !== null && (Re.clearTimeout(fe.current), fe.current = null);
  }, ie = (_, ee = !0) => {
    se(), fe.current = Re.setTimeout(Ge, _ || ne.current), ee && (re.current = V());
  }, st = (_) => {
    !H.current && !L.current && (Fe.current(_, Q), pe.current({ type: "active", prompted: !0 }, Q)), q.current = 0, M.current = V(), H.current = !0, ie(ke.current, !1);
  }, it = () => {
    se(), L.current || (Ie.current(null, Q), pe.current({ type: "idle" }, Q)), L.current = !0, K.current = V(), nt.current ? G() : H.current && (M.current = 0, H.current = !1);
  }, Ee = (_) => {
    se(), (L.current || H.current) && (xe.current(_, Q), pe.current({ type: "active", prompted: !1 }, Q)), H.current = !1, M.current = 0, L.current = !1, ce.current += V() - K.current, N.current += V() - K.current, _e(), ie();
  }, Ge = (_) => {
    if (!L.current) {
      Z.cancel && Z.cancel();
      let ee = V() - re.current;
      if (!(ne.current + ke.current < ee) && ke.current > 0 && !H.current) {
        E.current ? E.current.prompt() : st(_);
        return;
      }
      E.current ? E.current.idle() : it();
      return;
    }
    E.current ? E.current.active() : Ee(_);
  }, Qe = (_) => {
    if (!P && !re.current && (re.current = V(), xe.current(null, Q)), Z(_, Q), H.current)
      return;
    if (se(), !L.current && Oe.current.includes(_.type)) {
      Ge(_);
      return;
    }
    let ee = V() - re.current;
    if (L.current && !R || !L.current && ee >= ne.current) {
      Ge(_);
      return;
    }
    de.current = !1, q.current = 0, M.current = 0, ie(), D && B && He.current();
  }, Ce = j(Qe);
  z(() => {
    let _ = Se.current;
    _ && G(), S > 0 ? Ce.current = Vt(Qe, S) : Ce.current = Qe, _ && _e();
  }, [S, U, O, We, D, B]);
  let _e = () => {
    De && we.current && (Se.current || (ve.current.forEach((_) => {
      we.current.addEventListener(_, Ce.current, { capture: !0, passive: !0 });
    }), Se.current = !0));
  }, G = (_ = !1) => {
    De && we.current && (Se.current || _) && (ve.current.forEach((ee) => {
      we.current.removeEventListener(ee, Ce.current, { capture: !0 });
    }), Se.current = !1);
  }, Te = J((_) => Y.current ? !1 : (se(), _e(), L.current = !1, H.current = !1, de.current = !1, q.current = 0, M.current = 0, E.current && !_ && E.current.start(), ie(), !0), [fe, L, Y, ne, E]), Ne = J((_) => Y.current ? !1 : (se(), _e(), ye.current = V(), ce.current += V() - K.current, N.current += V() - K.current, ce.current = 0, L.current = !1, H.current = !1, de.current = !1, q.current = 0, M.current = 0, E.current && !_ && E.current.reset(), T || ie(), !0), [fe, L, ne, T, Y, E]), Je = J((_) => Y.current ? !1 : (se(), _e(), (L.current || H.current) && Ee(), L.current = !1, H.current = !1, de.current = !1, q.current = 0, M.current = 0, ye.current = V(), E.current && !_ && E.current.activate(), ie(), !0), [fe, L, H, Y, ne, E]), be = J((_ = !1) => Y.current || de.current ? !1 : (q.current = Pe(), de.current = !0, G(), se(), E.current && !_ && E.current.pause(), !0), [fe, Y, E]), Xe = J((_ = !1) => Y.current || !de.current ? !1 : (de.current = !1, H.current || _e(), L.current || ie(q.current), M.current && (M.current = V()), E.current && !_ && E.current.resume(), !0), [fe, ne, Y, q, E]), gt = J((_, ee) => (E.current ? (ee && ue.current(_, Q), E.current.message(_)) : ee && ue.current(_, Q), !0), [k]), _t = J(() => L.current, [L]), mt = J(() => H.current, [H]), wt = J(() => E.current ? E.current.isLeader : null, [E]), vt = J(() => E.current ? E.current.isLastActive : null, [E]), yt = J(() => E.current ? E.current.token : null, [E]), Pe = J(() => {
    if (de.current)
      return q.current;
    let _ = q.current ? q.current : ke.current + ne.current, ee = re.current ? V() - re.current : 0, Ve = Math.floor(_ - ee);
    return Ve < 0 ? 0 : Math.abs(Ve);
  }, [ne, ke, H, q, re]), ze = J(() => Math.round(V() - ye.current), [ye]), le = J(() => Math.round(V() - ge.current), [ge]), Le = J(() => K.current ? new Date(K.current) : null, [K]), Me = J(() => re.current ? new Date(re.current) : null, [re]), Ke = J(() => L.current ? Math.round(V() - K.current + ce.current) : Math.round(ce.current), [K, ce]), ot = J(() => L.current ? Math.round(V() - K.current + N.current) : Math.round(N.current), [K, N]), Ze = J(() => {
    let _ = Math.round(ze() - Ke());
    return _ >= 0 ? _ : 0;
  }, [K, ce]), bt = J(() => {
    let _ = Math.round(le() - ot());
    return _ >= 0 ? _ : 0;
  }, [K, ce]);
  z(() => {
    if (O > 0 && U > 0)
      throw new Error("❌ onAction can either be throttled or debounced, not both.");
    o && Zn(o);
    let _ = () => {
      E.current && E.current.close(), Z.cancel && Z.cancel(), se(), G(!0);
    };
    return De && window.addEventListener("beforeunload", _), () => {
      De && window.removeEventListener("beforeunload", _), E.current && E.current.close(), Z.cancel && Z.cancel(), se(), G(!0);
    };
  }, []), z(() => {
    E.current && E.current.close(), D ? E.current = new ss({ channelName: W, leaderElection: te, onPrompt: () => {
      st();
    }, onIdle: () => {
      it();
    }, onActive: () => {
      Ee();
    }, onMessage: (_) => {
      ue.current(_, Q);
    }, start: Te, reset: Ne, activate: Je, pause: be, resume: Xe }) : E.current = null;
  }, [D, W, te, Fe, Ie, xe, ue, Te, Ne, be, Xe]), z(() => {
    he.current || (se(), G(!0)), !(T || $) && (P ? Te() : _e());
  }, [T, P, $, he]), z(() => {
    if (!he.current) {
      let _ = [...(/* @__PURE__ */ new Set([...s, ...c])).values()];
      if (G(), ve.current = _, we.current = n, Oe.current = c, T || $)
        return;
      P ? Te() : _e();
    }
  }, [n, JSON.stringify(s), JSON.stringify(c), he, $, T, P]), z(() => {
    he.current && (he.current = !1);
  }, [he]);
  let Q = { message: gt, start: Te, reset: Ne, activate: Je, pause: be, resume: Xe, isIdle: _t, isPrompted: mt, isLeader: wt, isLastActiveTab: vt, getTabId: yt, getRemainingTime: Pe, getElapsedTime: ze, getTotalElapsedTime: le, getLastIdleTime: Le, getLastActiveTime: Me, getIdleTime: Ke, getTotalIdleTime: ot, getActiveTime: Ze, getTotalActiveTime: bt, setOnPresenceChange: (_) => {
    u = _, pe.current = _;
  }, setOnPrompt: (_) => {
    h = _, Fe.current = _;
  }, setOnIdle: (_) => {
    l = _, Ie.current = _;
  }, setOnActive: (_) => {
    p = _, xe.current = _;
  }, setOnAction: (_) => {
    g = _, We.current = _;
  }, setOnMessage: (_) => {
    k = _, ue.current = _;
  } };
  return Q;
}
var us = dr(null);
us.Consumer;
class It extends Error {
}
It.prototype.name = "InvalidTokenError";
function ls(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, r) => {
    let n = r.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function ds(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return ls(t);
  } catch {
    return atob(t);
  }
}
function hs(e, t) {
  if (typeof e != "string")
    throw new It("Invalid token specified: must be a string");
  t || (t = {});
  const r = t.header === !0 ? 0 : 1, n = e.split(".")[r];
  if (typeof n != "string")
    throw new It(`Invalid token specified: missing part #${r + 1}`);
  let s;
  try {
    s = ds(n);
  } catch (o) {
    throw new It(`Invalid token specified: invalid base64 for part #${r + 1} (${o.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (o) {
    throw new It(`Invalid token specified: invalid json for part #${r + 1} (${o.message})`);
  }
}
var fs = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, je, Ue, Dt = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(Dt || {});
((e) => {
  function t() {
    je = 3, Ue = fs;
  }
  e.reset = t;
  function r(s) {
    if (!(0 <= s && s <= 4))
      throw new Error("Invalid log level");
    je = s;
  }
  e.setLevel = r;
  function n(s) {
    Ue = s;
  }
  e.setLogger = n;
})(Dt || (Dt = {}));
var C = class Ae {
  constructor(t) {
    this._name = t;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...t) {
    je >= 4 && Ue.debug(Ae._format(this._name, this._method), ...t);
  }
  info(...t) {
    je >= 3 && Ue.info(Ae._format(this._name, this._method), ...t);
  }
  warn(...t) {
    je >= 2 && Ue.warn(Ae._format(this._name, this._method), ...t);
  }
  error(...t) {
    je >= 1 && Ue.error(Ae._format(this._name, this._method), ...t);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(t) {
    throw this.error(t), t;
  }
  create(t) {
    const r = Object.create(this);
    return r._method = t, r.debug("begin"), r;
  }
  static createStatic(t, r) {
    const n = new Ae(`${t}.${r}`);
    return n.debug("begin"), n;
  }
  static _format(t, r) {
    const n = `[${t}]`;
    return r ? `${n} ${r}:` : n;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(t, ...r) {
    je >= 4 && Ue.debug(Ae._format(t), ...r);
  }
  static info(t, ...r) {
    je >= 3 && Ue.info(Ae._format(t), ...r);
  }
  static warn(t, ...r) {
    je >= 2 && Ue.warn(Ae._format(t), ...r);
  }
  static error(t, ...r) {
    je >= 1 && Ue.error(Ae._format(t), ...r);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
Dt.reset();
var ps = "10000000-1000-4000-8000-100000000000", Pr = (e) => btoa([...new Uint8Array(e)].map((t) => String.fromCharCode(t)).join("")), dt = class xt {
  static _randomWord() {
    const t = new Uint32Array(1);
    return crypto.getRandomValues(t), t[0];
  }
  /**
   * Generates RFC4122 version 4 guid
   */
  static generateUUIDv4() {
    return ps.replace(
      /[018]/g,
      (t) => (+t ^ xt._randomWord() & 15 >> +t / 4).toString(16)
    ).replace(/-/g, "");
  }
  /**
   * PKCE: Generate a code verifier
   */
  static generateCodeVerifier() {
    return xt.generateUUIDv4() + xt.generateUUIDv4() + xt.generateUUIDv4();
  }
  /**
   * PKCE: Generate a code challenge
   */
  static async generateCodeChallenge(t) {
    if (!crypto.subtle)
      throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
    try {
      const r = new TextEncoder().encode(t), n = await crypto.subtle.digest("SHA-256", r);
      return Pr(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (r) {
      throw C.error("CryptoUtils.generateCodeChallenge", r), r;
    }
  }
  /**
   * Generates a base64-encoded string for a basic auth header
   */
  static generateBasicAuth(t, r) {
    const n = new TextEncoder().encode([t, r].join(":"));
    return Pr(n);
  }
}, Be = class {
  constructor(e) {
    this._name = e, this._logger = new C(`Event('${this._name}')`), this._callbacks = [];
  }
  addHandler(e) {
    return this._callbacks.push(e), () => this.removeHandler(e);
  }
  removeHandler(e) {
    const t = this._callbacks.lastIndexOf(e);
    t >= 0 && this._callbacks.splice(t, 1);
  }
  async raise(...e) {
    this._logger.debug("raise:", ...e);
    for (const t of this._callbacks)
      await t(...e);
  }
}, rr = class {
  // IMPORTANT: doesn't validate the token
  static decode(e) {
    try {
      return hs(e);
    } catch (t) {
      throw C.error("JwtUtils.decode", t), t;
    }
  }
}, Ar = class {
  /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */
  static center({ ...e }) {
    var t;
    return e.width == null && (e.width = (t = [800, 720, 600, 480].find((r) => r <= window.outerWidth / 1.618)) != null ? t : 360), e.left != null || (e.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - e.width) / 2))), e.height != null && (e.top != null || (e.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - e.height) / 2)))), e;
  }
  static serialize(e) {
    return Object.entries(e).filter(([, t]) => t != null).map(([t, r]) => `${t}=${typeof r != "boolean" ? r : r ? "yes" : "no"}`).join(",");
  }
}, $e = class Mt extends Be {
  constructor() {
    super(...arguments), this._logger = new C(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
      const t = this._expiration - Mt.getEpochTime();
      this._logger.debug("timer completes in", t), this._expiration <= Mt.getEpochTime() && (this.cancel(), super.raise());
    };
  }
  // get the time
  static getEpochTime() {
    return Math.floor(Date.now() / 1e3);
  }
  init(t) {
    const r = this._logger.create("init");
    t = Math.max(Math.floor(t), 1);
    const n = Mt.getEpochTime() + t;
    if (this.expiration === n && this._timerHandle) {
      r.debug("skipping since already initialized for expiration at", this.expiration);
      return;
    }
    this.cancel(), r.debug("using duration", t), this._expiration = n;
    const s = Math.min(t, 5);
    this._timerHandle = setInterval(this._callback, s * 1e3);
  }
  get expiration() {
    return this._expiration;
  }
  cancel() {
    this._logger.create("cancel"), this._timerHandle && (clearInterval(this._timerHandle), this._timerHandle = null);
  }
}, nr = class {
  static readParams(e, t = "query") {
    if (!e)
      throw new TypeError("Invalid URL");
    const r = new URL(e, "http://127.0.0.1")[t === "fragment" ? "hash" : "search"];
    return new URLSearchParams(r.slice(1));
  }
}, sr = ";", tt = class extends Error {
  constructor(e, t) {
    var r, n, s;
    if (super(e.error_description || e.error || ""), this.form = t, this.name = "ErrorResponse", !e.error)
      throw C.error("ErrorResponse", "No error passed"), new Error("No error passed");
    this.error = e.error, this.error_description = (r = e.error_description) != null ? r : null, this.error_uri = (n = e.error_uri) != null ? n : null, this.state = e.userState, this.session_state = (s = e.session_state) != null ? s : null, this.url_state = e.url_state;
  }
}, gr = class extends Error {
  constructor(e) {
    super(e), this.name = "ErrorTimeout";
  }
}, gs = class {
  constructor(e) {
    this._logger = new C("AccessTokenEvents"), this._expiringTimer = new $e("Access token expiring"), this._expiredTimer = new $e("Access token expired"), this._expiringNotificationTimeInSeconds = e.expiringNotificationTimeInSeconds;
  }
  load(e) {
    const t = this._logger.create("load");
    if (e.access_token && e.expires_in !== void 0) {
      const r = e.expires_in;
      if (t.debug("access token present, remaining duration:", r), r > 0) {
        let s = r - this._expiringNotificationTimeInSeconds;
        s <= 0 && (s = 1), t.debug("registering expiring timer, raising in", s, "seconds"), this._expiringTimer.init(s);
      } else
        t.debug("canceling existing expiring timer because we're past expiration."), this._expiringTimer.cancel();
      const n = r + 1;
      t.debug("registering expired timer, raising in", n, "seconds"), this._expiredTimer.init(n);
    } else
      this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  unload() {
    this._logger.debug("unload: canceling existing access token timers"), this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  /**
   * Add callback: Raised prior to the access token expiring.
   */
  addAccessTokenExpiring(e) {
    return this._expiringTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised prior to the access token expiring.
   */
  removeAccessTokenExpiring(e) {
    this._expiringTimer.removeHandler(e);
  }
  /**
   * Add callback: Raised after the access token has expired.
   */
  addAccessTokenExpired(e) {
    return this._expiredTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised after the access token has expired.
   */
  removeAccessTokenExpired(e) {
    this._expiredTimer.removeHandler(e);
  }
}, _s = class {
  constructor(e, t, r, n, s) {
    this._callback = e, this._client_id = t, this._intervalInSeconds = n, this._stopOnError = s, this._logger = new C("CheckSessionIFrame"), this._timer = null, this._session_state = null, this._message = (c) => {
      c.origin === this._frame_origin && c.source === this._frame.contentWindow && (c.data === "error" ? (this._logger.error("error message from check session op iframe"), this._stopOnError && this.stop()) : c.data === "changed" ? (this._logger.debug("changed message from check session op iframe"), this.stop(), this._callback()) : this._logger.debug(c.data + " message from check session op iframe"));
    };
    const o = new URL(r);
    this._frame_origin = o.origin, this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "fixed", this._frame.style.left = "-1000px", this._frame.style.top = "0", this._frame.width = "0", this._frame.height = "0", this._frame.src = o.href;
  }
  load() {
    return new Promise((e) => {
      this._frame.onload = () => {
        e();
      }, window.document.body.appendChild(this._frame), window.addEventListener("message", this._message, !1);
    });
  }
  start(e) {
    if (this._session_state === e)
      return;
    this._logger.create("start"), this.stop(), this._session_state = e;
    const t = () => {
      !this._frame.contentWindow || !this._session_state || this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
    };
    t(), this._timer = setInterval(t, this._intervalInSeconds * 1e3);
  }
  stop() {
    this._logger.create("stop"), this._session_state = null, this._timer && (clearInterval(this._timer), this._timer = null);
  }
}, rn = class {
  constructor() {
    this._logger = new C("InMemoryWebStorage"), this._data = {};
  }
  clear() {
    this._logger.create("clear"), this._data = {};
  }
  getItem(e) {
    return this._logger.create(`getItem('${e}')`), this._data[e];
  }
  setItem(e, t) {
    this._logger.create(`setItem('${e}')`), this._data[e] = t;
  }
  removeItem(e) {
    this._logger.create(`removeItem('${e}')`), delete this._data[e];
  }
  get length() {
    return Object.getOwnPropertyNames(this._data).length;
  }
  key(e) {
    return Object.getOwnPropertyNames(this._data)[e];
  }
}, _r = class {
  constructor(e = [], t = null, r = {}) {
    this._jwtHandler = t, this._extraHeaders = r, this._logger = new C("JsonService"), this._contentTypes = [], this._contentTypes.push(...e, "application/json"), t && this._contentTypes.push("application/jwt");
  }
  async fetchWithTimeout(e, t = {}) {
    const { timeoutInSeconds: r, ...n } = t;
    if (!r)
      return await fetch(e, n);
    const s = new AbortController(), o = setTimeout(() => s.abort(), r * 1e3);
    try {
      return await fetch(e, {
        ...t,
        signal: s.signal
      });
    } catch (c) {
      throw c instanceof DOMException && c.name === "AbortError" ? new gr("Network timed out") : c;
    } finally {
      clearTimeout(o);
    }
  }
  async getJson(e, {
    token: t,
    credentials: r
  } = {}) {
    const n = this._logger.create("getJson"), s = {
      Accept: this._contentTypes.join(", ")
    };
    t && (n.debug("token passed, setting Authorization header"), s.Authorization = "Bearer " + t), this.appendExtraHeaders(s);
    let o;
    try {
      n.debug("url:", e), o = await this.fetchWithTimeout(e, { method: "GET", headers: s, credentials: r });
    } catch (h) {
      throw n.error("Network Error"), h;
    }
    n.debug("HTTP response received, status", o.status);
    const c = o.headers.get("Content-Type");
    if (c && !this._contentTypes.find((h) => c.startsWith(h)) && n.throw(new Error(`Invalid response Content-Type: ${c ?? "undefined"}, from URL: ${e}`)), o.ok && this._jwtHandler && c != null && c.startsWith("application/jwt"))
      return await this._jwtHandler(await o.text());
    let u;
    try {
      u = await o.json();
    } catch (h) {
      throw n.error("Error parsing JSON response", h), o.ok ? h : new Error(`${o.statusText} (${o.status})`);
    }
    if (!o.ok)
      throw n.error("Error from server:", u), u.error ? new tt(u) : new Error(`${o.statusText} (${o.status}): ${JSON.stringify(u)}`);
    return u;
  }
  async postForm(e, {
    body: t,
    basicAuth: r,
    timeoutInSeconds: n,
    initCredentials: s
  }) {
    const o = this._logger.create("postForm"), c = {
      Accept: this._contentTypes.join(", "),
      "Content-Type": "application/x-www-form-urlencoded"
    };
    r !== void 0 && (c.Authorization = "Basic " + r), this.appendExtraHeaders(c);
    let u;
    try {
      o.debug("url:", e), u = await this.fetchWithTimeout(e, { method: "POST", headers: c, body: t, timeoutInSeconds: n, credentials: s });
    } catch (g) {
      throw o.error("Network error"), g;
    }
    o.debug("HTTP response received, status", u.status);
    const h = u.headers.get("Content-Type");
    if (h && !this._contentTypes.find((g) => h.startsWith(g)))
      throw new Error(`Invalid response Content-Type: ${h ?? "undefined"}, from URL: ${e}`);
    const l = await u.text();
    let p = {};
    if (l)
      try {
        p = JSON.parse(l);
      } catch (g) {
        throw o.error("Error parsing JSON response", g), u.ok ? g : new Error(`${u.statusText} (${u.status})`);
      }
    if (!u.ok)
      throw o.error("Error from server:", p), p.error ? new tt(p, t) : new Error(`${u.statusText} (${u.status}): ${JSON.stringify(p)}`);
    return p;
  }
  appendExtraHeaders(e) {
    const t = this._logger.create("appendExtraHeaders"), r = Object.keys(this._extraHeaders), n = [
      "authorization",
      "accept",
      "content-type"
    ];
    r.length !== 0 && r.forEach((s) => {
      if (n.includes(s.toLocaleLowerCase())) {
        t.warn("Protected header could not be overridden", s, n);
        return;
      }
      const o = typeof this._extraHeaders[s] == "function" ? this._extraHeaders[s]() : this._extraHeaders[s];
      o && o !== "" && (e[s] = o);
    });
  }
}, ms = class {
  constructor(e) {
    this._settings = e, this._logger = new C("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new _r(
      ["application/jwk-set+json"],
      null,
      this._settings.extraHeaders
    ), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
  }
  resetSigningKeys() {
    this._signingKeys = null;
  }
  async getMetadata() {
    const e = this._logger.create("getMetadata");
    if (this._metadata)
      return e.debug("using cached values"), this._metadata;
    if (!this._metadataUrl)
      throw e.throw(new Error("No authority or metadataUrl configured on settings")), null;
    e.debug("getting metadata from", this._metadataUrl);
    const t = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials });
    return e.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, this._settings.metadataSeed, t), this._metadata;
  }
  getIssuer() {
    return this._getMetadataProperty("issuer");
  }
  getAuthorizationEndpoint() {
    return this._getMetadataProperty("authorization_endpoint");
  }
  getUserInfoEndpoint() {
    return this._getMetadataProperty("userinfo_endpoint");
  }
  getTokenEndpoint(e = !0) {
    return this._getMetadataProperty("token_endpoint", e);
  }
  getCheckSessionIframe() {
    return this._getMetadataProperty("check_session_iframe", !0);
  }
  getEndSessionEndpoint() {
    return this._getMetadataProperty("end_session_endpoint", !0);
  }
  getRevocationEndpoint(e = !0) {
    return this._getMetadataProperty("revocation_endpoint", e);
  }
  getKeysEndpoint(e = !0) {
    return this._getMetadataProperty("jwks_uri", e);
  }
  async _getMetadataProperty(e, t = !1) {
    const r = this._logger.create(`_getMetadataProperty('${e}')`), n = await this.getMetadata();
    if (r.debug("resolved"), n[e] === void 0) {
      if (t === !0) {
        r.warn("Metadata does not contain optional property");
        return;
      }
      r.throw(new Error("Metadata does not contain property " + e));
    }
    return n[e];
  }
  async getSigningKeys() {
    const e = this._logger.create("getSigningKeys");
    if (this._signingKeys)
      return e.debug("returning signingKeys from cache"), this._signingKeys;
    const t = await this.getKeysEndpoint(!1);
    e.debug("got jwks_uri", t);
    const r = await this._jsonService.getJson(t);
    if (e.debug("got key set", r), !Array.isArray(r.keys))
      throw e.throw(new Error("Missing keys on keyset")), null;
    return this._signingKeys = r.keys, this._signingKeys;
  }
}, nn = class {
  constructor({
    prefix: e = "oidc.",
    store: t = localStorage
  } = {}) {
    this._logger = new C("WebStorageStateStore"), this._store = t, this._prefix = e;
  }
  async set(e, t) {
    this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, t);
  }
  async get(e) {
    return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
  }
  async remove(e) {
    this._logger.create(`remove('${e}')`), e = this._prefix + e;
    const t = await this._store.getItem(e);
    return await this._store.removeItem(e), t;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const e = await this._store.length, t = [];
    for (let r = 0; r < e; r++) {
      const n = await this._store.key(r);
      n && n.indexOf(this._prefix) === 0 && t.push(n.substr(this._prefix.length));
    }
    return t;
  }
}, ws = "code", vs = "openid", ys = "client_secret_post", bs = 60 * 15, ir = class {
  constructor({
    // metadata related
    authority: e,
    metadataUrl: t,
    metadata: r,
    signingKeys: n,
    metadataSeed: s,
    // client related
    client_id: o,
    client_secret: c,
    response_type: u = ws,
    scope: h = vs,
    redirect_uri: l,
    post_logout_redirect_uri: p,
    client_authentication: g = ys,
    // optional protocol
    prompt: k,
    display: O,
    max_age: U,
    ui_locales: S,
    acr_values: P,
    resource: T,
    response_mode: R,
    // behavior flags
    filterProtocolClaims: D = !0,
    loadUserInfo: W = !1,
    staleStateAgeInSeconds: B = bs,
    mergeClaimsStrategy: te = { array: "replace" },
    disablePKCE: $ = !1,
    // other behavior
    stateStore: ge,
    revokeTokenAdditionalContentTypes: ye,
    fetchRequestCredentials: K,
    refreshTokenAllowedScope: re,
    // extra
    extraQueryParams: ce = {},
    extraTokenParams: N = {},
    extraHeaders: M = {}
  }) {
    if (this.authority = e, t ? this.metadataUrl = t : (this.metadataUrl = e, e && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = r, this.metadataSeed = s, this.signingKeys = n, this.client_id = o, this.client_secret = c, this.response_type = u, this.scope = h, this.redirect_uri = l, this.post_logout_redirect_uri = p, this.client_authentication = g, this.prompt = k, this.display = O, this.max_age = U, this.ui_locales = S, this.acr_values = P, this.resource = T, this.response_mode = R, this.filterProtocolClaims = D ?? !0, this.loadUserInfo = !!W, this.staleStateAgeInSeconds = B, this.mergeClaimsStrategy = te, this.disablePKCE = !!$, this.revokeTokenAdditionalContentTypes = ye, this.fetchRequestCredentials = K || "same-origin", ge)
      this.stateStore = ge;
    else {
      const q = typeof window < "u" ? window.localStorage : new rn();
      this.stateStore = new nn({ store: q });
    }
    this.refreshTokenAllowedScope = re, this.extraQueryParams = ce, this.extraTokenParams = N, this.extraHeaders = M;
  }
}, Ss = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new C("UserInfoService"), this._getClaimsFromJwt = async (r) => {
      const n = this._logger.create("_getClaimsFromJwt");
      try {
        const s = rr.decode(r);
        return n.debug("JWT decoding successful"), s;
      } catch (s) {
        throw n.error("Error parsing JWT response"), s;
      }
    }, this._jsonService = new _r(
      void 0,
      this._getClaimsFromJwt,
      this._settings.extraHeaders
    );
  }
  async getClaims(e) {
    const t = this._logger.create("getClaims");
    e || this._logger.throw(new Error("No token passed"));
    const r = await this._metadataService.getUserInfoEndpoint();
    t.debug("got userinfo url", r);
    const n = await this._jsonService.getJson(r, {
      token: e,
      credentials: this._settings.fetchRequestCredentials
    });
    return t.debug("got claims", n), n;
  }
}, sn = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new C("TokenClient"), this._jsonService = new _r(
      this._settings.revokeTokenAdditionalContentTypes,
      null,
      this._settings.extraHeaders
    );
  }
  /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */
  async exchangeCode({
    grant_type: e = "authorization_code",
    redirect_uri: t = this._settings.redirect_uri,
    client_id: r = this._settings.client_id,
    client_secret: n = this._settings.client_secret,
    ...s
  }) {
    const o = this._logger.create("exchangeCode");
    r || o.throw(new Error("A client_id is required")), t || o.throw(new Error("A redirect_uri is required")), s.code || o.throw(new Error("A code is required"));
    const c = new URLSearchParams({ grant_type: e, redirect_uri: t });
    for (const [p, g] of Object.entries(s))
      g != null && c.set(p, g);
    let u;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!n)
          throw o.throw(new Error("A client_secret is required")), null;
        u = dt.generateBasicAuth(r, n);
        break;
      case "client_secret_post":
        c.append("client_id", r), n && c.append("client_secret", n);
        break;
    }
    const h = await this._metadataService.getTokenEndpoint(!1);
    o.debug("got token endpoint");
    const l = await this._jsonService.postForm(h, { body: c, basicAuth: u, initCredentials: this._settings.fetchRequestCredentials });
    return o.debug("got response"), l;
  }
  /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */
  async exchangeCredentials({
    grant_type: e = "password",
    client_id: t = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    scope: n = this._settings.scope,
    ...s
  }) {
    const o = this._logger.create("exchangeCredentials");
    t || o.throw(new Error("A client_id is required"));
    const c = new URLSearchParams({ grant_type: e, scope: n });
    for (const [p, g] of Object.entries(s))
      g != null && c.set(p, g);
    let u;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw o.throw(new Error("A client_secret is required")), null;
        u = dt.generateBasicAuth(t, r);
        break;
      case "client_secret_post":
        c.append("client_id", t), r && c.append("client_secret", r);
        break;
    }
    const h = await this._metadataService.getTokenEndpoint(!1);
    o.debug("got token endpoint");
    const l = await this._jsonService.postForm(h, { body: c, basicAuth: u, initCredentials: this._settings.fetchRequestCredentials });
    return o.debug("got response"), l;
  }
  /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */
  async exchangeRefreshToken({
    grant_type: e = "refresh_token",
    client_id: t = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    timeoutInSeconds: n,
    ...s
  }) {
    const o = this._logger.create("exchangeRefreshToken");
    t || o.throw(new Error("A client_id is required")), s.refresh_token || o.throw(new Error("A refresh_token is required"));
    const c = new URLSearchParams({ grant_type: e });
    for (const [p, g] of Object.entries(s))
      Array.isArray(g) ? g.forEach((k) => c.append(p, k)) : g != null && c.set(p, g);
    let u;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw o.throw(new Error("A client_secret is required")), null;
        u = dt.generateBasicAuth(t, r);
        break;
      case "client_secret_post":
        c.append("client_id", t), r && c.append("client_secret", r);
        break;
    }
    const h = await this._metadataService.getTokenEndpoint(!1);
    o.debug("got token endpoint");
    const l = await this._jsonService.postForm(h, { body: c, basicAuth: u, timeoutInSeconds: n, initCredentials: this._settings.fetchRequestCredentials });
    return o.debug("got response"), l;
  }
  /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */
  async revoke(e) {
    var t;
    const r = this._logger.create("revoke");
    e.token || r.throw(new Error("A token is required"));
    const n = await this._metadataService.getRevocationEndpoint(!1);
    r.debug(`got revocation endpoint, revoking ${(t = e.token_type_hint) != null ? t : "default token type"}`);
    const s = new URLSearchParams();
    for (const [o, c] of Object.entries(e))
      c != null && s.set(o, c);
    s.set("client_id", this._settings.client_id), this._settings.client_secret && s.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(n, { body: s }), r.debug("got response");
  }
}, ks = class {
  constructor(e, t, r) {
    this._settings = e, this._metadataService = t, this._claimsService = r, this._logger = new C("ResponseValidator"), this._userInfoService = new Ss(this._settings, this._metadataService), this._tokenClient = new sn(this._settings, this._metadataService);
  }
  async validateSigninResponse(e, t) {
    const r = this._logger.create("validateSigninResponse");
    this._processSigninState(e, t), r.debug("state processed"), await this._processCode(e, t), r.debug("code processed"), e.isOpenId && this._validateIdTokenAttributes(e), r.debug("tokens validated"), await this._processClaims(e, t == null ? void 0 : t.skipUserInfo, e.isOpenId), r.debug("claims processed");
  }
  async validateCredentialsResponse(e, t) {
    const r = this._logger.create("validateCredentialsResponse");
    e.isOpenId && e.id_token && this._validateIdTokenAttributes(e), r.debug("tokens validated"), await this._processClaims(e, t, e.isOpenId), r.debug("claims processed");
  }
  async validateRefreshResponse(e, t) {
    const r = this._logger.create("validateRefreshResponse");
    e.userState = t.data, e.session_state != null || (e.session_state = t.session_state), e.scope != null || (e.scope = t.scope), e.isOpenId && e.id_token && (this._validateIdTokenAttributes(e, t.id_token), r.debug("ID Token validated")), e.id_token || (e.id_token = t.id_token, e.profile = t.profile);
    const n = e.isOpenId && !!e.id_token;
    await this._processClaims(e, !1, n), r.debug("claims processed");
  }
  validateSignoutResponse(e, t) {
    const r = this._logger.create("validateSignoutResponse");
    if (t.id !== e.state && r.throw(new Error("State does not match")), r.debug("state validated"), e.userState = t.data, e.error)
      throw r.warn("Response was error", e.error), new tt(e);
  }
  _processSigninState(e, t) {
    const r = this._logger.create("_processSigninState");
    if (t.id !== e.state && r.throw(new Error("State does not match")), t.client_id || r.throw(new Error("No client_id on state")), t.authority || r.throw(new Error("No authority on state")), this._settings.authority !== t.authority && r.throw(new Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== t.client_id && r.throw(new Error("client_id mismatch on settings vs. signin state")), r.debug("state validated"), e.userState = t.data, e.url_state = t.url_state, e.scope != null || (e.scope = t.scope), e.error)
      throw r.warn("Response was error", e.error), new tt(e);
    t.code_verifier && !e.code && r.throw(new Error("Expected code in response"));
  }
  async _processClaims(e, t = !1, r = !0) {
    const n = this._logger.create("_processClaims");
    if (e.profile = this._claimsService.filterProtocolClaims(e.profile), t || !this._settings.loadUserInfo || !e.access_token) {
      n.debug("not loading user info");
      return;
    }
    n.debug("loading user info");
    const s = await this._userInfoService.getClaims(e.access_token);
    n.debug("user info claims received from user info endpoint"), r && s.sub !== e.profile.sub && n.throw(new Error("subject from UserInfo response does not match subject in ID Token")), e.profile = this._claimsService.mergeClaims(e.profile, this._claimsService.filterProtocolClaims(s)), n.debug("user info claims received, updated profile:", e.profile);
  }
  async _processCode(e, t) {
    const r = this._logger.create("_processCode");
    if (e.code) {
      r.debug("Validating code");
      const n = await this._tokenClient.exchangeCode({
        client_id: t.client_id,
        client_secret: t.client_secret,
        code: e.code,
        redirect_uri: t.redirect_uri,
        code_verifier: t.code_verifier,
        ...t.extraTokenParams
      });
      Object.assign(e, n);
    } else
      r.debug("No code to process");
  }
  _validateIdTokenAttributes(e, t) {
    var r;
    const n = this._logger.create("_validateIdTokenAttributes");
    n.debug("decoding ID Token JWT");
    const s = rr.decode((r = e.id_token) != null ? r : "");
    if (s.sub || n.throw(new Error("ID Token is missing a subject claim")), t) {
      const o = rr.decode(t);
      s.sub !== o.sub && n.throw(new Error("sub in id_token does not match current sub")), s.auth_time && s.auth_time !== o.auth_time && n.throw(new Error("auth_time in id_token does not match original auth_time")), s.azp && s.azp !== o.azp && n.throw(new Error("azp in id_token does not match original azp")), !s.azp && o.azp && n.throw(new Error("azp not in id_token, but present in original id_token"));
    }
    e.profile = s;
  }
}, $t = class or {
  constructor(t) {
    this.id = t.id || dt.generateUUIDv4(), this.data = t.data, t.created && t.created > 0 ? this.created = t.created : this.created = $e.getEpochTime(), this.request_type = t.request_type, this.url_state = t.url_state;
  }
  toStorageString() {
    return new C("State").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state
    });
  }
  static fromStorageString(t) {
    return C.createStatic("State", "fromStorageString"), Promise.resolve(new or(JSON.parse(t)));
  }
  static async clearStaleState(t, r) {
    const n = C.createStatic("State", "clearStaleState"), s = $e.getEpochTime() - r, o = await t.getAllKeys();
    n.debug("got keys", o);
    for (let c = 0; c < o.length; c++) {
      const u = o[c], h = await t.get(u);
      let l = !1;
      if (h)
        try {
          const p = await or.fromStorageString(h);
          n.debug("got item from key:", u, p.created), p.created <= s && (l = !0);
        } catch (p) {
          n.error("Error parsing state for key:", u, p), l = !0;
        }
      else
        n.debug("no item in storage for key:", u), l = !0;
      l && (n.debug("removed item for key:", u), t.remove(u));
    }
  }
}, on = class ar extends $t {
  constructor(t) {
    super(t), this.code_verifier = t.code_verifier, this.code_challenge = t.code_challenge, this.authority = t.authority, this.client_id = t.client_id, this.redirect_uri = t.redirect_uri, this.scope = t.scope, this.client_secret = t.client_secret, this.extraTokenParams = t.extraTokenParams, this.response_mode = t.response_mode, this.skipUserInfo = t.skipUserInfo;
  }
  static async create(t) {
    const r = t.code_verifier === !0 ? dt.generateCodeVerifier() : t.code_verifier || void 0, n = r ? await dt.generateCodeChallenge(r) : void 0;
    return new ar({
      ...t,
      code_verifier: r,
      code_challenge: n
    });
  }
  toStorageString() {
    return new C("SigninState").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state,
      code_verifier: this.code_verifier,
      authority: this.authority,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      scope: this.scope,
      client_secret: this.client_secret,
      extraTokenParams: this.extraTokenParams,
      response_mode: this.response_mode,
      skipUserInfo: this.skipUserInfo
    });
  }
  static fromStorageString(t) {
    C.createStatic("SigninState", "fromStorageString");
    const r = JSON.parse(t);
    return ar.create(r);
  }
}, an = class cn {
  constructor(t) {
    this.url = t.url, this.state = t.state;
  }
  static async create({
    // mandatory
    url: t,
    authority: r,
    client_id: n,
    redirect_uri: s,
    response_type: o,
    scope: c,
    // optional
    state_data: u,
    response_mode: h,
    request_type: l,
    client_secret: p,
    nonce: g,
    url_state: k,
    resource: O,
    skipUserInfo: U,
    extraQueryParams: S,
    extraTokenParams: P,
    disablePKCE: T,
    ...R
  }) {
    if (!t)
      throw this._logger.error("create: No url passed"), new Error("url");
    if (!n)
      throw this._logger.error("create: No client_id passed"), new Error("client_id");
    if (!s)
      throw this._logger.error("create: No redirect_uri passed"), new Error("redirect_uri");
    if (!o)
      throw this._logger.error("create: No response_type passed"), new Error("response_type");
    if (!c)
      throw this._logger.error("create: No scope passed"), new Error("scope");
    if (!r)
      throw this._logger.error("create: No authority passed"), new Error("authority");
    const D = await on.create({
      data: u,
      request_type: l,
      url_state: k,
      code_verifier: !T,
      client_id: n,
      authority: r,
      redirect_uri: s,
      response_mode: h,
      client_secret: p,
      scope: c,
      extraTokenParams: P,
      skipUserInfo: U
    }), W = new URL(t);
    W.searchParams.append("client_id", n), W.searchParams.append("redirect_uri", s), W.searchParams.append("response_type", o), W.searchParams.append("scope", c), g && W.searchParams.append("nonce", g);
    let B = D.id;
    k && (B = `${B}${sr}${k}`), W.searchParams.append("state", B), D.code_challenge && (W.searchParams.append("code_challenge", D.code_challenge), W.searchParams.append("code_challenge_method", "S256")), O && (Array.isArray(O) ? O : [O]).forEach((te) => W.searchParams.append("resource", te));
    for (const [te, $] of Object.entries({ response_mode: h, ...R, ...S }))
      $ != null && W.searchParams.append(te, $.toString());
    return new cn({
      url: W.href,
      state: D
    });
  }
};
an._logger = new C("SigninRequest");
var Es = an, Ts = "openid", Bt = class {
  constructor(e) {
    if (this.access_token = "", this.token_type = "", this.profile = {}, this.state = e.get("state"), this.session_state = e.get("session_state"), this.state) {
      const t = decodeURIComponent(this.state).split(sr);
      this.state = t[0], t.length > 1 && (this.url_state = t.slice(1).join(sr));
    }
    this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri"), this.code = e.get("code");
  }
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - $e.getEpochTime();
  }
  set expires_in(e) {
    typeof e == "string" && (e = Number(e)), e !== void 0 && e >= 0 && (this.expires_at = Math.floor(e) + $e.getEpochTime());
  }
  get isOpenId() {
    var e;
    return ((e = this.scope) == null ? void 0 : e.split(" ").includes(Ts)) || !!this.id_token;
  }
}, Rs = class {
  constructor({
    url: e,
    state_data: t,
    id_token_hint: r,
    post_logout_redirect_uri: n,
    extraQueryParams: s,
    request_type: o,
    client_id: c
  }) {
    if (this._logger = new C("SignoutRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    const u = new URL(e);
    r && u.searchParams.append("id_token_hint", r), c && u.searchParams.append("client_id", c), n && (u.searchParams.append("post_logout_redirect_uri", n), t && (this.state = new $t({ data: t, request_type: o }), u.searchParams.append("state", this.state.id)));
    for (const [h, l] of Object.entries({ ...s }))
      l != null && u.searchParams.append(h, l.toString());
    this.url = u.href;
  }
}, Os = class {
  constructor(e) {
    this.state = e.get("state"), this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri");
  }
}, Is = [
  "nbf",
  "jti",
  "auth_time",
  "nonce",
  "acr",
  "amr",
  "azp",
  "at_hash"
  // https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
], xs = ["sub", "iss", "aud", "exp", "iat"], Cs = class {
  constructor(e) {
    this._settings = e, this._logger = new C("ClaimsService");
  }
  filterProtocolClaims(e) {
    const t = { ...e };
    if (this._settings.filterProtocolClaims) {
      let r;
      Array.isArray(this._settings.filterProtocolClaims) ? r = this._settings.filterProtocolClaims : r = Is;
      for (const n of r)
        xs.includes(n) || delete t[n];
    }
    return t;
  }
  mergeClaims(e, t) {
    const r = { ...e };
    for (const [n, s] of Object.entries(t))
      if (r[n] !== s)
        if (Array.isArray(r[n]) || Array.isArray(s))
          if (this._settings.mergeClaimsStrategy.array == "replace")
            r[n] = s;
          else {
            const o = Array.isArray(r[n]) ? r[n] : [r[n]];
            for (const c of Array.isArray(s) ? s : [s])
              o.includes(c) || o.push(c);
            r[n] = o;
          }
        else
          typeof r[n] == "object" && typeof s == "object" ? r[n] = this.mergeClaims(r[n], s) : r[n] = s;
    return r;
  }
}, Ps = class {
  constructor(e, t) {
    this._logger = new C("OidcClient"), this.settings = e instanceof ir ? e : new ir(e), this.metadataService = t ?? new ms(this.settings), this._claimsService = new Cs(this.settings), this._validator = new ks(this.settings, this.metadataService, this._claimsService), this._tokenClient = new sn(this.settings, this.metadataService);
  }
  async createSigninRequest({
    state: e,
    request: t,
    request_uri: r,
    request_type: n,
    id_token_hint: s,
    login_hint: o,
    skipUserInfo: c,
    nonce: u,
    url_state: h,
    response_type: l = this.settings.response_type,
    scope: p = this.settings.scope,
    redirect_uri: g = this.settings.redirect_uri,
    prompt: k = this.settings.prompt,
    display: O = this.settings.display,
    max_age: U = this.settings.max_age,
    ui_locales: S = this.settings.ui_locales,
    acr_values: P = this.settings.acr_values,
    resource: T = this.settings.resource,
    response_mode: R = this.settings.response_mode,
    extraQueryParams: D = this.settings.extraQueryParams,
    extraTokenParams: W = this.settings.extraTokenParams
  }) {
    const B = this._logger.create("createSigninRequest");
    if (l !== "code")
      throw new Error("Only the Authorization Code flow (with PKCE) is supported");
    const te = await this.metadataService.getAuthorizationEndpoint();
    B.debug("Received authorization endpoint", te);
    const $ = await Es.create({
      url: te,
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri: g,
      response_type: l,
      scope: p,
      state_data: e,
      url_state: h,
      prompt: k,
      display: O,
      max_age: U,
      ui_locales: S,
      id_token_hint: s,
      login_hint: o,
      acr_values: P,
      resource: T,
      request: t,
      request_uri: r,
      extraQueryParams: D,
      extraTokenParams: W,
      request_type: n,
      response_mode: R,
      client_secret: this.settings.client_secret,
      skipUserInfo: c,
      nonce: u,
      disablePKCE: this.settings.disablePKCE
    });
    await this.clearStaleState();
    const ge = $.state;
    return await this.settings.stateStore.set(ge.id, ge.toStorageString()), $;
  }
  async readSigninResponseState(e, t = !1) {
    const r = this._logger.create("readSigninResponseState"), n = new Bt(nr.readParams(e, this.settings.response_mode));
    if (!n.state)
      throw r.throw(new Error("No state in response")), null;
    const s = await this.settings.stateStore[t ? "remove" : "get"](n.state);
    if (!s)
      throw r.throw(new Error("No matching state found in storage")), null;
    return { state: await on.fromStorageString(s), response: n };
  }
  async processSigninResponse(e) {
    const t = this._logger.create("processSigninResponse"), { state: r, response: n } = await this.readSigninResponseState(e, !0);
    return t.debug("received state from storage; validating response"), await this._validator.validateSigninResponse(n, r), n;
  }
  async processResourceOwnerPasswordCredentials({
    username: e,
    password: t,
    skipUserInfo: r = !1,
    extraTokenParams: n = {}
  }) {
    const s = await this._tokenClient.exchangeCredentials({ username: e, password: t, ...n }), o = new Bt(new URLSearchParams());
    return Object.assign(o, s), await this._validator.validateCredentialsResponse(o, r), o;
  }
  async useRefreshToken({
    state: e,
    redirect_uri: t,
    resource: r,
    timeoutInSeconds: n,
    extraTokenParams: s
  }) {
    var o;
    const c = this._logger.create("useRefreshToken");
    let u;
    if (this.settings.refreshTokenAllowedScope === void 0)
      u = e.scope;
    else {
      const p = this.settings.refreshTokenAllowedScope.split(" ");
      u = (((o = e.scope) == null ? void 0 : o.split(" ")) || []).filter((g) => p.includes(g)).join(" ");
    }
    const h = await this._tokenClient.exchangeRefreshToken({
      refresh_token: e.refresh_token,
      // provide the (possible filtered) scope list
      scope: u,
      redirect_uri: t,
      resource: r,
      timeoutInSeconds: n,
      ...s
    }), l = new Bt(new URLSearchParams());
    return Object.assign(l, h), c.debug("validating response", l), await this._validator.validateRefreshResponse(l, {
      ...e,
      // override the scope in the state handed over to the validator
      // so it can set the granted scope to the requested scope in case none is included in the response
      scope: u
    }), l;
  }
  async createSignoutRequest({
    state: e,
    id_token_hint: t,
    client_id: r,
    request_type: n,
    post_logout_redirect_uri: s = this.settings.post_logout_redirect_uri,
    extraQueryParams: o = this.settings.extraQueryParams
  } = {}) {
    const c = this._logger.create("createSignoutRequest"), u = await this.metadataService.getEndSessionEndpoint();
    if (!u)
      throw c.throw(new Error("No end session endpoint")), null;
    c.debug("Received end session endpoint", u), !r && s && !t && (r = this.settings.client_id);
    const h = new Rs({
      url: u,
      id_token_hint: t,
      client_id: r,
      post_logout_redirect_uri: s,
      state_data: e,
      extraQueryParams: o,
      request_type: n
    });
    await this.clearStaleState();
    const l = h.state;
    return l && (c.debug("Signout request has state to persist"), await this.settings.stateStore.set(l.id, l.toStorageString())), h;
  }
  async readSignoutResponseState(e, t = !1) {
    const r = this._logger.create("readSignoutResponseState"), n = new Os(nr.readParams(e, this.settings.response_mode));
    if (!n.state) {
      if (r.debug("No state in response"), n.error)
        throw r.warn("Response was error:", n.error), new tt(n);
      return { state: void 0, response: n };
    }
    const s = await this.settings.stateStore[t ? "remove" : "get"](n.state);
    if (!s)
      throw r.throw(new Error("No matching state found in storage")), null;
    return { state: await $t.fromStorageString(s), response: n };
  }
  async processSignoutResponse(e) {
    const t = this._logger.create("processSignoutResponse"), { state: r, response: n } = await this.readSignoutResponseState(e, !0);
    return r ? (t.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(n, r)) : t.debug("No state from storage; skipping response validation"), n;
  }
  clearStaleState() {
    return this._logger.create("clearStaleState"), $t.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
  }
  async revokeToken(e, t) {
    return this._logger.create("revokeToken"), await this._tokenClient.revoke({
      token: e,
      token_type_hint: t
    });
  }
}, As = class {
  constructor(e) {
    this._userManager = e, this._logger = new C("SessionMonitor"), this._start = async (t) => {
      const r = t.session_state;
      if (!r)
        return;
      const n = this._logger.create("_start");
      if (t.profile ? (this._sub = t.profile.sub, n.debug("session_state", r, ", sub", this._sub)) : (this._sub = void 0, n.debug("session_state", r, ", anonymous user")), this._checkSessionIFrame) {
        this._checkSessionIFrame.start(r);
        return;
      }
      try {
        const s = await this._userManager.metadataService.getCheckSessionIframe();
        if (s) {
          n.debug("initializing check session iframe");
          const o = this._userManager.settings.client_id, c = this._userManager.settings.checkSessionIntervalInSeconds, u = this._userManager.settings.stopCheckSessionOnError, h = new _s(this._callback, o, s, c, u);
          await h.load(), this._checkSessionIFrame = h, h.start(r);
        } else
          n.warn("no check session iframe found in the metadata");
      } catch (s) {
        n.error("Error from getCheckSessionIframe:", s instanceof Error ? s.message : s);
      }
    }, this._stop = () => {
      const t = this._logger.create("_stop");
      if (this._sub = void 0, this._checkSessionIFrame && this._checkSessionIFrame.stop(), this._userManager.settings.monitorAnonymousSession) {
        const r = setInterval(async () => {
          clearInterval(r);
          try {
            const n = await this._userManager.querySessionStatus();
            if (n) {
              const s = {
                session_state: n.session_state,
                profile: n.sub ? {
                  sub: n.sub
                } : null
              };
              this._start(s);
            }
          } catch (n) {
            t.error("error from querySessionStatus", n instanceof Error ? n.message : n);
          }
        }, 1e3);
      }
    }, this._callback = async () => {
      const t = this._logger.create("_callback");
      try {
        const r = await this._userManager.querySessionStatus();
        let n = !0;
        r && this._checkSessionIFrame ? r.sub === this._sub ? (n = !1, this._checkSessionIFrame.start(r.session_state), t.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", r.session_state), await this._userManager.events._raiseUserSessionChanged()) : t.debug("different subject signed into OP", r.sub) : t.debug("subject no longer signed into OP"), n ? this._sub ? await this._userManager.events._raiseUserSignedOut() : await this._userManager.events._raiseUserSignedIn() : t.debug("no change in session detected, no event to raise");
      } catch (r) {
        this._sub && (t.debug("Error calling queryCurrentSigninSession; raising signed out event", r), await this._userManager.events._raiseUserSignedOut());
      }
    }, e || this._logger.throw(new Error("No user manager passed")), this._userManager.events.addUserLoaded(this._start), this._userManager.events.addUserUnloaded(this._stop), this._init().catch((t) => {
      this._logger.error(t);
    });
  }
  async _init() {
    this._logger.create("_init");
    const e = await this._userManager.getUser();
    if (e)
      this._start(e);
    else if (this._userManager.settings.monitorAnonymousSession) {
      const t = await this._userManager.querySessionStatus();
      if (t) {
        const r = {
          session_state: t.session_state,
          profile: t.sub ? {
            sub: t.sub
          } : null
        };
        this._start(r);
      }
    }
  }
}, Yt = class un {
  constructor(t) {
    var r;
    this.id_token = t.id_token, this.session_state = (r = t.session_state) != null ? r : null, this.access_token = t.access_token, this.refresh_token = t.refresh_token, this.token_type = t.token_type, this.scope = t.scope, this.profile = t.profile, this.expires_at = t.expires_at, this.state = t.userState, this.url_state = t.url_state;
  }
  /** Computed number of seconds the access token has remaining. */
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - $e.getEpochTime();
  }
  set expires_in(t) {
    t !== void 0 && (this.expires_at = Math.floor(t) + $e.getEpochTime());
  }
  /** Computed value indicating if the access token is expired. */
  get expired() {
    const t = this.expires_in;
    if (t !== void 0)
      return t <= 0;
  }
  /** Array representing the parsed values from the `scope`. */
  get scopes() {
    var t, r;
    return (r = (t = this.scope) == null ? void 0 : t.split(" ")) != null ? r : [];
  }
  toStorageString() {
    return new C("User").create("toStorageString"), JSON.stringify({
      id_token: this.id_token,
      session_state: this.session_state,
      access_token: this.access_token,
      refresh_token: this.refresh_token,
      token_type: this.token_type,
      scope: this.scope,
      profile: this.profile,
      expires_at: this.expires_at
    });
  }
  static fromStorageString(t) {
    return C.createStatic("User", "fromStorageString"), new un(JSON.parse(t));
  }
}, jr = "oidc-client", ln = class {
  constructor() {
    this._abort = new Be("Window navigation aborted"), this._disposeHandlers = /* @__PURE__ */ new Set(), this._window = null;
  }
  async navigate(e) {
    const t = this._logger.create("navigate");
    if (!this._window)
      throw new Error("Attempted to navigate on a disposed window");
    t.debug("setting URL in window"), this._window.location.replace(e.url);
    const { url: r, keepOpen: n } = await new Promise((s, o) => {
      const c = (u) => {
        var h;
        const l = u.data, p = (h = e.scriptOrigin) != null ? h : window.location.origin;
        if (!(u.origin !== p || (l == null ? void 0 : l.source) !== jr)) {
          try {
            const g = nr.readParams(l.url, e.response_mode).get("state");
            if (g || t.warn("no state found in response url"), u.source !== this._window && g !== e.state)
              return;
          } catch {
            this._dispose(), o(new Error("Invalid response from window"));
          }
          s(l);
        }
      };
      window.addEventListener("message", c, !1), this._disposeHandlers.add(() => window.removeEventListener("message", c, !1)), this._disposeHandlers.add(this._abort.addHandler((u) => {
        this._dispose(), o(u);
      }));
    });
    return t.debug("got response from window"), this._dispose(), n || this.close(), { url: r };
  }
  _dispose() {
    this._logger.create("_dispose");
    for (const e of this._disposeHandlers)
      e();
    this._disposeHandlers.clear();
  }
  static _notifyParent(e, t, r = !1, n = window.location.origin) {
    e.postMessage({
      source: jr,
      url: t,
      keepOpen: r
    }, n);
  }
}, dn = {
  location: !1,
  toolbar: !1,
  height: 640,
  closePopupWindowAfterInSeconds: -1
}, hn = "_blank", js = 60, Us = 2, fn = 10, Ns = class extends ir {
  constructor(e) {
    const {
      popup_redirect_uri: t = e.redirect_uri,
      popup_post_logout_redirect_uri: r = e.post_logout_redirect_uri,
      popupWindowFeatures: n = dn,
      popupWindowTarget: s = hn,
      redirectMethod: o = "assign",
      redirectTarget: c = "self",
      iframeNotifyParentOrigin: u = e.iframeNotifyParentOrigin,
      iframeScriptOrigin: h = e.iframeScriptOrigin,
      silent_redirect_uri: l = e.redirect_uri,
      silentRequestTimeoutInSeconds: p = fn,
      automaticSilentRenew: g = !0,
      validateSubOnSilentRenew: k = !0,
      includeIdTokenInSilentRenew: O = !1,
      monitorSession: U = !1,
      monitorAnonymousSession: S = !1,
      checkSessionIntervalInSeconds: P = Us,
      query_status_response_type: T = "code",
      stopCheckSessionOnError: R = !0,
      revokeTokenTypes: D = ["access_token", "refresh_token"],
      revokeTokensOnSignout: W = !1,
      includeIdTokenInSilentSignout: B = !1,
      accessTokenExpiringNotificationTimeInSeconds: te = js,
      userStore: $
    } = e;
    if (super(e), this.popup_redirect_uri = t, this.popup_post_logout_redirect_uri = r, this.popupWindowFeatures = n, this.popupWindowTarget = s, this.redirectMethod = o, this.redirectTarget = c, this.iframeNotifyParentOrigin = u, this.iframeScriptOrigin = h, this.silent_redirect_uri = l, this.silentRequestTimeoutInSeconds = p, this.automaticSilentRenew = g, this.validateSubOnSilentRenew = k, this.includeIdTokenInSilentRenew = O, this.monitorSession = U, this.monitorAnonymousSession = S, this.checkSessionIntervalInSeconds = P, this.stopCheckSessionOnError = R, this.query_status_response_type = T, this.revokeTokenTypes = D, this.revokeTokensOnSignout = W, this.includeIdTokenInSilentSignout = B, this.accessTokenExpiringNotificationTimeInSeconds = te, $)
      this.userStore = $;
    else {
      const ge = typeof window < "u" ? window.sessionStorage : new rn();
      this.userStore = new nn({ store: ge });
    }
  }
}, Ur = class pn extends ln {
  constructor({
    silentRequestTimeoutInSeconds: t = fn
  }) {
    super(), this._logger = new C("IFrameWindow"), this._timeoutInSeconds = t, this._frame = pn.createHiddenIframe(), this._window = this._frame.contentWindow;
  }
  static createHiddenIframe() {
    const t = window.document.createElement("iframe");
    return t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-1000px", t.style.top = "0", t.width = "0", t.height = "0", window.document.body.appendChild(t), t;
  }
  async navigate(t) {
    this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
    const r = setTimeout(() => void this._abort.raise(new gr("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
    return this._disposeHandlers.add(() => clearTimeout(r)), await super.navigate(t);
  }
  close() {
    var t;
    this._frame && (this._frame.parentNode && (this._frame.addEventListener("load", (r) => {
      var n;
      const s = r.target;
      (n = s.parentNode) == null || n.removeChild(s), this._abort.raise(new Error("IFrame removed from DOM"));
    }, !0), (t = this._frame.contentWindow) == null || t.location.replace("about:blank")), this._frame = null), this._window = null;
  }
  static notifyParent(t, r) {
    return super._notifyParent(window.parent, t, !1, r);
  }
}, Ls = class {
  constructor(e) {
    this._settings = e, this._logger = new C("IFrameNavigator");
  }
  async prepare({
    silentRequestTimeoutInSeconds: e = this._settings.silentRequestTimeoutInSeconds
  }) {
    return new Ur({ silentRequestTimeoutInSeconds: e });
  }
  async callback(e) {
    this._logger.create("callback"), Ur.notifyParent(e, this._settings.iframeNotifyParentOrigin);
  }
}, Ms = 500, qs = 1e3, Nr = class extends ln {
  constructor({
    popupWindowTarget: e = hn,
    popupWindowFeatures: t = {}
  }) {
    super(), this._logger = new C("PopupWindow");
    const r = Ar.center({ ...dn, ...t });
    this._window = window.open(void 0, e, Ar.serialize(r)), t.closePopupWindowAfterInSeconds && t.closePopupWindowAfterInSeconds > 0 && setTimeout(() => {
      if (!this._window || typeof this._window.closed != "boolean" || this._window.closed) {
        this._abort.raise(new Error("Popup blocked by user"));
        return;
      }
      this.close();
    }, t.closePopupWindowAfterInSeconds * qs);
  }
  async navigate(e) {
    var t;
    (t = this._window) == null || t.focus();
    const r = setInterval(() => {
      (!this._window || this._window.closed) && this._abort.raise(new Error("Popup closed by user"));
    }, Ms);
    return this._disposeHandlers.add(() => clearInterval(r)), await super.navigate(e);
  }
  close() {
    this._window && (this._window.closed || (this._window.close(), this._abort.raise(new Error("Popup closed")))), this._window = null;
  }
  static notifyOpener(e, t) {
    if (!window.opener)
      throw new Error("No window.opener. Can't complete notification.");
    return super._notifyParent(window.opener, e, t);
  }
}, Ds = class {
  constructor(e) {
    this._settings = e, this._logger = new C("PopupNavigator");
  }
  async prepare({
    popupWindowFeatures: e = this._settings.popupWindowFeatures,
    popupWindowTarget: t = this._settings.popupWindowTarget
  }) {
    return new Nr({ popupWindowFeatures: e, popupWindowTarget: t });
  }
  async callback(e, { keepOpen: t = !1 }) {
    this._logger.create("callback"), Nr.notifyOpener(e, t);
  }
}, $s = class {
  constructor(e) {
    this._settings = e, this._logger = new C("RedirectNavigator");
  }
  async prepare({
    redirectMethod: e = this._settings.redirectMethod,
    redirectTarget: t = this._settings.redirectTarget
  }) {
    var r;
    this._logger.create("prepare");
    let n = window.self;
    t === "top" && (n = (r = window.top) != null ? r : window.self);
    const s = n.location[e].bind(n.location);
    let o;
    return {
      navigate: async (c) => {
        this._logger.create("navigate");
        const u = new Promise((h, l) => {
          o = l;
        });
        return s(c.url), await u;
      },
      close: () => {
        this._logger.create("close"), o == null || o(new Error("Redirect aborted")), n.stop();
      }
    };
  }
  async callback() {
  }
}, Fs = class extends gs {
  constructor(e) {
    super({ expiringNotificationTimeInSeconds: e.accessTokenExpiringNotificationTimeInSeconds }), this._logger = new C("UserManagerEvents"), this._userLoaded = new Be("User loaded"), this._userUnloaded = new Be("User unloaded"), this._silentRenewError = new Be("Silent renew error"), this._userSignedIn = new Be("User signed in"), this._userSignedOut = new Be("User signed out"), this._userSessionChanged = new Be("User session changed");
  }
  async load(e, t = !0) {
    super.load(e), t && await this._userLoaded.raise(e);
  }
  async unload() {
    super.unload(), await this._userUnloaded.raise();
  }
  /**
   * Add callback: Raised when a user session has been established (or re-established).
   */
  addUserLoaded(e) {
    return this._userLoaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */
  removeUserLoaded(e) {
    return this._userLoaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when a user session has been terminated.
   */
  addUserUnloaded(e) {
    return this._userUnloaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been terminated.
   */
  removeUserUnloaded(e) {
    return this._userUnloaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when the automatic silent renew has failed.
   */
  addSilentRenewError(e) {
    return this._silentRenewError.addHandler(e);
  }
  /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */
  removeSilentRenewError(e) {
    return this._silentRenewError.removeHandler(e);
  }
  /**
   * @internal
   */
  async _raiseSilentRenewError(e) {
    await this._silentRenewError.raise(e);
  }
  /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedIn(e) {
    return this._userSignedIn.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */
  removeUserSignedIn(e) {
    this._userSignedIn.removeHandler(e);
  }
  /**
   * @internal
   */
  async _raiseUserSignedIn() {
    await this._userSignedIn.raise();
  }
  /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedOut(e) {
    return this._userSignedOut.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */
  removeUserSignedOut(e) {
    this._userSignedOut.removeHandler(e);
  }
  /**
   * @internal
   */
  async _raiseUserSignedOut() {
    await this._userSignedOut.raise();
  }
  /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSessionChanged(e) {
    return this._userSessionChanged.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */
  removeUserSessionChanged(e) {
    this._userSessionChanged.removeHandler(e);
  }
  /**
   * @internal
   */
  async _raiseUserSessionChanged() {
    await this._userSessionChanged.raise();
  }
}, Ws = class {
  constructor(e) {
    this._userManager = e, this._logger = new C("SilentRenewService"), this._isStarted = !1, this._retryTimer = new $e("Retry Silent Renew"), this._tokenExpiring = async () => {
      const t = this._logger.create("_tokenExpiring");
      try {
        await this._userManager.signinSilent(), t.debug("silent token renewal successful");
      } catch (r) {
        if (r instanceof gr) {
          t.warn("ErrorTimeout from signinSilent:", r, "retry in 5s"), this._retryTimer.init(5);
          return;
        }
        t.error("Error from signinSilent:", r), await this._userManager.events._raiseSilentRenewError(r);
      }
    };
  }
  async start() {
    const e = this._logger.create("start");
    if (!this._isStarted) {
      this._isStarted = !0, this._userManager.events.addAccessTokenExpiring(this._tokenExpiring), this._retryTimer.addHandler(this._tokenExpiring);
      try {
        await this._userManager.getUser();
      } catch (t) {
        e.error("getUser error", t);
      }
    }
  }
  stop() {
    this._isStarted && (this._retryTimer.cancel(), this._retryTimer.removeHandler(this._tokenExpiring), this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring), this._isStarted = !1);
  }
}, Hs = class {
  constructor(e) {
    this.refresh_token = e.refresh_token, this.id_token = e.id_token, this.session_state = e.session_state, this.scope = e.scope, this.profile = e.profile, this.data = e.state;
  }
}, Js = class {
  constructor(e, t, r, n) {
    this._logger = new C("UserManager"), this.settings = new Ns(e), this._client = new Ps(e), this._redirectNavigator = t ?? new $s(this.settings), this._popupNavigator = r ?? new Ds(this.settings), this._iframeNavigator = n ?? new Ls(this.settings), this._events = new Fs(this.settings), this._silentRenewService = new Ws(this), this.settings.automaticSilentRenew && this.startSilentRenew(), this._sessionMonitor = null, this.settings.monitorSession && (this._sessionMonitor = new As(this));
  }
  /**
   * Get object used to register for events raised by the `UserManager`.
   */
  get events() {
    return this._events;
  }
  /**
   * Get object used to access the metadata configuration of the identity provider.
   */
  get metadataService() {
    return this._client.metadataService;
  }
  /**
   * Load the `User` object for the currently authenticated user.
   *
   * @returns A promise
   */
  async getUser() {
    const e = this._logger.create("getUser"), t = await this._loadUser();
    return t ? (e.info("user loaded"), await this._events.load(t, !1), t) : (e.info("user not found in storage"), null);
  }
  /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */
  async removeUser() {
    const e = this._logger.create("removeUser");
    await this.storeUser(null), e.info("user removed from storage"), await this._events.unload();
  }
  /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */
  async signinRedirect(e = {}) {
    this._logger.create("signinRedirect");
    const {
      redirectMethod: t,
      ...r
    } = e, n = await this._redirectNavigator.prepare({ redirectMethod: t });
    await this._signinStart({
      request_type: "si:r",
      ...r
    }, n);
  }
  /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommend to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signinRedirectCallback"), r = await this._signinEnd(e);
    return r.profile && r.profile.sub ? t.info("success, signed in subject", r.profile.sub) : t.info("no subject"), r;
  }
  /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */
  async signinResourceOwnerCredentials({
    username: e,
    password: t,
    skipUserInfo: r = !1
  }) {
    const n = this._logger.create("signinResourceOwnerCredential"), s = await this._client.processResourceOwnerPasswordCredentials({ username: e, password: t, skipUserInfo: r, extraTokenParams: this.settings.extraTokenParams });
    n.debug("got signin response");
    const o = await this._buildUser(s);
    return o.profile && o.profile.sub ? n.info("success, signed in subject", o.profile.sub) : n.info("no subject"), o;
  }
  /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */
  async signinPopup(e = {}) {
    const t = this._logger.create("signinPopup"), {
      popupWindowFeatures: r,
      popupWindowTarget: n,
      ...s
    } = e, o = this.settings.popup_redirect_uri;
    o || t.throw(new Error("No popup_redirect_uri configured"));
    const c = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: n }), u = await this._signin({
      request_type: "si:p",
      redirect_uri: o,
      display: "popup",
      ...s
    }, c);
    return u && (u.profile && u.profile.sub ? t.info("success, signed in subject", u.profile.sub) : t.info("no subject")), u;
  }
  /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommend to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinPopupCallback(e = window.location.href, t = !1) {
    const r = this._logger.create("signinPopupCallback");
    await this._popupNavigator.callback(e, { keepOpen: t }), r.info("success");
  }
  /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */
  async signinSilent(e = {}) {
    var t;
    const r = this._logger.create("signinSilent"), {
      silentRequestTimeoutInSeconds: n,
      ...s
    } = e;
    let o = await this._loadUser();
    if (o != null && o.refresh_token) {
      r.debug("using refresh token");
      const l = new Hs(o);
      return await this._useRefreshToken({
        state: l,
        redirect_uri: s.redirect_uri,
        resource: s.resource,
        extraTokenParams: s.extraTokenParams,
        timeoutInSeconds: n
      });
    }
    const c = this.settings.silent_redirect_uri;
    c || r.throw(new Error("No silent_redirect_uri configured"));
    let u;
    o && this.settings.validateSubOnSilentRenew && (r.debug("subject prior to silent renew:", o.profile.sub), u = o.profile.sub);
    const h = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: n });
    return o = await this._signin({
      request_type: "si:s",
      redirect_uri: c,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? o == null ? void 0 : o.id_token : void 0,
      ...s
    }, h, u), o && ((t = o.profile) != null && t.sub ? r.info("success, signed in subject", o.profile.sub) : r.info("no subject")), o;
  }
  async _useRefreshToken(e) {
    const t = await this._client.useRefreshToken({
      ...e,
      timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds
    }), r = new Yt({ ...e.state, ...t });
    return await this.storeUser(r), await this._events.load(r), r;
  }
  /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommend to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinSilentCallback(e = window.location.href) {
    const t = this._logger.create("signinSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout can not processed.
   */
  async signinCallback(e = window.location.href) {
    const { state: t } = await this._client.readSigninResponseState(e);
    switch (t.request_type) {
      case "si:r":
        return await this.signinRedirectCallback(e);
      case "si:p":
        return await this.signinPopupCallback(e);
      case "si:s":
        return await this.signinSilentCallback(e);
      default:
        throw new Error("invalid response_type in state");
    }
  }
  /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout can not processed.
   */
  async signoutCallback(e = window.location.href, t = !1) {
    const { state: r } = await this._client.readSignoutResponseState(e);
    if (r)
      switch (r.request_type) {
        case "so:r":
          await this.signoutRedirectCallback(e);
          break;
        case "so:p":
          await this.signoutPopupCallback(e, t);
          break;
        case "so:s":
          await this.signoutSilentCallback(e);
          break;
        default:
          throw new Error("invalid response_type in state");
      }
  }
  /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */
  async querySessionStatus(e = {}) {
    const t = this._logger.create("querySessionStatus"), {
      silentRequestTimeoutInSeconds: r,
      ...n
    } = e, s = this.settings.silent_redirect_uri;
    s || t.throw(new Error("No silent_redirect_uri configured"));
    const o = await this._loadUser(), c = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r }), u = await this._signinStart({
      request_type: "si:s",
      // this acts like a signin silent
      redirect_uri: s,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? o == null ? void 0 : o.id_token : void 0,
      response_type: this.settings.query_status_response_type,
      scope: "openid",
      skipUserInfo: !0,
      ...n
    }, c);
    try {
      const h = await this._client.processSigninResponse(u.url);
      return t.debug("got signin response"), h.session_state && h.profile.sub ? (t.info("success for subject", h.profile.sub), {
        session_state: h.session_state,
        sub: h.profile.sub
      }) : (t.info("success, user not authenticated"), null);
    } catch (h) {
      if (this.settings.monitorAnonymousSession && h instanceof tt)
        switch (h.error) {
          case "login_required":
          case "consent_required":
          case "interaction_required":
          case "account_selection_required":
            return t.info("success for anonymous user"), {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              session_state: h.session_state
            };
        }
      throw h;
    }
  }
  async _signin(e, t, r) {
    const n = await this._signinStart(e, t);
    return await this._signinEnd(n.url, r);
  }
  async _signinStart(e, t) {
    const r = this._logger.create("_signinStart");
    try {
      const n = await this._client.createSigninRequest(e);
      return r.debug("got signin request"), await t.navigate({
        url: n.url,
        state: n.state.id,
        response_mode: n.state.response_mode,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (n) {
      throw r.debug("error after preparing navigator, closing navigator window"), t.close(), n;
    }
  }
  async _signinEnd(e, t) {
    const r = this._logger.create("_signinEnd"), n = await this._client.processSigninResponse(e);
    return r.debug("got signin response"), await this._buildUser(n, t);
  }
  async _buildUser(e, t) {
    const r = this._logger.create("_buildUser"), n = new Yt(e);
    if (t) {
      if (t !== n.profile.sub)
        throw r.debug("current user does not match user returned from signin. sub from signin:", n.profile.sub), new tt({ ...e, error: "login_required" });
      r.debug("current user matches user returned from signin");
    }
    return await this.storeUser(n), r.debug("user stored"), await this._events.load(n), n;
  }
  /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutRedirect(e = {}) {
    const t = this._logger.create("signoutRedirect"), {
      redirectMethod: r,
      ...n
    } = e, s = await this._redirectNavigator.prepare({ redirectMethod: r });
    await this._signoutStart({
      request_type: "so:r",
      post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
      ...n
    }, s), t.info("success");
  }
  /**
   * Process response (callback) from the end session endpoint.
   * It is recommend to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signoutRedirectCallback"), r = await this._signoutEnd(e);
    return t.info("success"), r;
  }
  /**
   * Trigger a redirect of a popup window window to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutPopup(e = {}) {
    const t = this._logger.create("signoutPopup"), {
      popupWindowFeatures: r,
      popupWindowTarget: n,
      ...s
    } = e, o = this.settings.popup_post_logout_redirect_uri, c = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: n });
    await this._signout({
      request_type: "so:p",
      post_logout_redirect_uri: o,
      // we're putting a dummy entry in here because we
      // need a unique id from the state for notification
      // to the parent window, which is necessary if we
      // plan to return back to the client after signout
      // and so we can close the popup after signout
      state: o == null ? void 0 : {},
      ...s
    }, c), t.info("success");
  }
  /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommend to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutPopupCallback(e = window.location.href, t = !1) {
    const r = this._logger.create("signoutPopupCallback");
    await this._popupNavigator.callback(e, { keepOpen: t }), r.info("success");
  }
  async _signout(e, t) {
    const r = await this._signoutStart(e, t);
    return await this._signoutEnd(r.url);
  }
  async _signoutStart(e = {}, t) {
    var r;
    const n = this._logger.create("_signoutStart");
    try {
      const s = await this._loadUser();
      n.debug("loaded current user from storage"), this.settings.revokeTokensOnSignout && await this._revokeInternal(s);
      const o = e.id_token_hint || s && s.id_token;
      o && (n.debug("setting id_token_hint in signout request"), e.id_token_hint = o), await this.removeUser(), n.debug("user removed, creating signout request");
      const c = await this._client.createSignoutRequest(e);
      return n.debug("got signout request"), await t.navigate({
        url: c.url,
        state: (r = c.state) == null ? void 0 : r.id,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (s) {
      throw n.debug("error after preparing navigator, closing navigator window"), t.close(), s;
    }
  }
  async _signoutEnd(e) {
    const t = this._logger.create("_signoutEnd"), r = await this._client.processSignoutResponse(e);
    return t.debug("got signout response"), r;
  }
  /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutSilent(e = {}) {
    var t;
    const r = this._logger.create("signoutSilent"), {
      silentRequestTimeoutInSeconds: n,
      ...s
    } = e, o = this.settings.includeIdTokenInSilentSignout ? (t = await this._loadUser()) == null ? void 0 : t.id_token : void 0, c = this.settings.popup_post_logout_redirect_uri, u = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: n });
    await this._signout({
      request_type: "so:s",
      post_logout_redirect_uri: c,
      id_token_hint: o,
      ...s
    }, u), r.info("success");
  }
  /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommend to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutSilentCallback(e = window.location.href) {
    const t = this._logger.create("signoutSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async revokeTokens(e) {
    const t = await this._loadUser();
    await this._revokeInternal(t, e);
  }
  async _revokeInternal(e, t = this.settings.revokeTokenTypes) {
    const r = this._logger.create("_revokeInternal");
    if (!e)
      return;
    const n = t.filter((s) => typeof e[s] == "string");
    if (!n.length) {
      r.debug("no need to revoke due to no token(s)");
      return;
    }
    for (const s of n)
      await this._client.revokeToken(
        e[s],
        // eslint-disable-line @typescript-eslint/no-non-null-assertion
        s
      ), r.info(`${s} revoked successfully`), s !== "access_token" && (e[s] = null);
    await this.storeUser(e), r.debug("user stored"), await this._events.load(e);
  }
  /**
   * Enables silent renew for the `UserManager`.
   */
  startSilentRenew() {
    this._logger.create("startSilentRenew"), this._silentRenewService.start();
  }
  /**
   * Disables silent renew for the `UserManager`.
   */
  stopSilentRenew() {
    this._silentRenewService.stop();
  }
  get _userStoreKey() {
    return `user:${this.settings.authority}:${this.settings.client_id}`;
  }
  async _loadUser() {
    const e = this._logger.create("_loadUser"), t = await this.settings.userStore.get(this._userStoreKey);
    return t ? (e.debug("user storageString loaded"), Yt.fromStorageString(t)) : (e.debug("no user storageString"), null);
  }
  async storeUser(e) {
    const t = this._logger.create("storeUser");
    if (e) {
      t.debug("storing user");
      const r = e.toStorageString();
      await this.settings.userStore.set(this._userStoreKey, r);
    } else
      this._logger.debug("removing user"), await this.settings.userStore.remove(this._userStoreKey);
  }
  /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */
  async clearStaleState() {
    await this._client.clearStaleState();
  }
}, mr = rt.createContext(void 0);
mr.displayName = "AuthContext";
var zs = {
  isLoading: !0,
  isAuthenticated: !1
}, Ks = (e, t) => {
  switch (t.type) {
    case "INITIALISED":
    case "USER_LOADED":
      return {
        ...e,
        user: t.user,
        isLoading: !1,
        isAuthenticated: t.user ? !t.user.expired : !1,
        error: void 0
      };
    case "USER_SIGNED_OUT":
    case "USER_UNLOADED":
      return {
        ...e,
        user: void 0,
        isAuthenticated: !1
      };
    case "NAVIGATOR_INIT":
      return {
        ...e,
        isLoading: !0,
        activeNavigator: t.method
      };
    case "NAVIGATOR_CLOSE":
      return {
        ...e,
        isLoading: !1,
        activeNavigator: void 0
      };
    case "ERROR":
      return {
        ...e,
        isLoading: !1,
        error: t.error
      };
    default:
      return {
        ...e,
        isLoading: !1,
        error: new Error(`unknown type ${t.type}`)
      };
  }
}, gn = (e = window.location) => {
  let t = new URLSearchParams(e.search);
  return !!((t.get("code") || t.get("error")) && t.get("state") || (t = new URLSearchParams(e.hash.replace("#", "?")), (t.get("code") || t.get("error")) && t.get("state")));
}, _n = (e) => (t) => t instanceof Error ? t : new Error(e), Vs = _n("Sign-in failed"), Bs = _n("Sign-out failed"), Ys = [
  "clearStaleState",
  "querySessionStatus",
  "revokeTokens",
  "startSilentRenew",
  "stopSilentRenew"
], Gs = [
  "signinPopup",
  "signinSilent",
  "signinRedirect",
  "signinResourceOwnerCredentials",
  "signoutPopup",
  "signoutRedirect",
  "signoutSilent"
], Gt = (e) => () => {
  throw new Error(
    `UserManager#${e} was called from an unsupported context. If this is a server-rendered page, defer this call with useEffect() or pass a custom UserManager implementation.`
  );
}, Lr = typeof window > "u" ? null : Js, Qs = (e) => {
  const {
    children: t,
    onSigninCallback: r,
    skipSigninCallback: n,
    matchSignoutCallback: s,
    onSignoutCallback: o,
    onRemoveUser: c,
    userManager: u = null,
    ...h
  } = e, [l] = hr(() => u ?? (Lr ? new Lr(h) : { settings: h })), [p, g] = Pn(Ks, zs), k = Pt(
    () => Object.assign(
      {
        settings: l.settings,
        events: l.events
      },
      Object.fromEntries(
        Ys.map((S) => {
          var P, T;
          return [
            S,
            (T = (P = l[S]) == null ? void 0 : P.bind(l)) != null ? T : Gt(S)
          ];
        })
      ),
      Object.fromEntries(
        Gs.map((S) => [
          S,
          l[S] ? async (P) => {
            g({
              type: "NAVIGATOR_INIT",
              method: S
            });
            try {
              return await l[S](P);
            } catch (T) {
              return g({ type: "ERROR", error: T }), null;
            } finally {
              g({ type: "NAVIGATOR_CLOSE" });
            }
          } : Gt(S)
        ])
      )
    ),
    [l]
  ), O = j(!1);
  z(() => {
    !l || O.current || (O.current = !0, (async () => {
      let S = null;
      try {
        gn() && !n && (S = await l.signinCallback(), r && await r(S)), S = S || await l.getUser(), g({ type: "INITIALISED", user: S });
      } catch (P) {
        g({ type: "ERROR", error: Vs(P) });
      }
      try {
        s && s(l.settings) && (await l.signoutCallback(), o && await o());
      } catch (P) {
        g({ type: "ERROR", error: Bs(P) });
      }
    })());
  }, [l, n, r, o, s]), z(() => {
    if (!l)
      return;
    const S = (D) => {
      g({ type: "USER_LOADED", user: D });
    };
    l.events.addUserLoaded(S);
    const P = () => {
      g({ type: "USER_UNLOADED" });
    };
    l.events.addUserUnloaded(P);
    const T = () => {
      g({ type: "USER_SIGNED_OUT" });
    };
    l.events.addUserSignedOut(T);
    const R = (D) => {
      g({ type: "ERROR", error: D });
    };
    return l.events.addSilentRenewError(R), () => {
      l.events.removeUserLoaded(S), l.events.removeUserUnloaded(P), l.events.removeUserSignedOut(T), l.events.removeSilentRenewError(R);
    };
  }, [l]);
  const U = J(
    l ? () => l.removeUser().then(c) : Gt("removeUser"),
    [l, c]
  );
  return /* @__PURE__ */ rt.createElement(
    mr.Provider,
    {
      value: {
        ...p,
        ...k,
        removeUser: U
      }
    },
    t
  );
}, Xs = () => {
  const e = rt.useContext(mr);
  return e || console.warn("AuthProvider context is undefined, please verify you are calling useAuth() as child of a <AuthProvider> component."), e;
};
const Zs = ({
  children: e,
  authController: t
}) => {
  const r = t.config;
  return /* @__PURE__ */ tr.jsx(
    Qs,
    {
      authority: r.authority,
      scope: r.scope,
      client_id: r.clientId,
      response_type: r.responseType,
      accessTokenExpiringNotificationTimeInSeconds: r.accessTokenExpiringNotificationTimeInSeconds,
      redirect_uri: r.redirectUri,
      silent_redirect_uri: r.silentRedirectUri,
      automaticSilentRenew: r.automaticSilentRenew,
      onSigninCallback: r.onSignInCallback,
      children: /* @__PURE__ */ tr.jsx(ei, { authController: t, children: e })
    }
  );
}, mn = dr({
  user: null,
  isLoading: !0,
  isAuthenticated: !1,
  sessionExpired: !1,
  signOutSilent: () => Promise.resolve(),
  singOutRedirect: () => Promise.resolve()
}), ei = ({
  children: e,
  authController: t
}) => {
  const r = Xs(), [n, s] = hr(!1), o = cs({
    onIdle: () => s(!0),
    startManually: !0,
    timeout: 30 * 6e4
  });
  z(() => {
    o.start();
    const l = () => {
      o.activate();
    };
    return document.addEventListener("keydown", l, !0), document.addEventListener("mousemove", l, !0), () => {
      document.removeEventListener("keydown", l, !0), document.removeEventListener("mousemove", l, !0);
    };
  }, [o]);
  const c = J(async () => {
    t.updateTokenChannel(), console.info("TokenAuthApp: automatically sign-in"), await r.signinRedirect(), console.info("sign-in finished");
  }, [r, t]), u = J(async () => {
    var l;
    await (r == null ? void 0 : r.signoutRedirect({
      id_token_hint: (l = r == null ? void 0 : r.user) == null ? void 0 : l.id_token,
      post_logout_redirect_uri: window.location.href
    }));
  }, [r]);
  z(() => {
    !gn() && !r.isAuthenticated && !r.isLoading && !r.error && r.activeNavigator !== "signoutRedirect" && c();
  }, [r, u, c]), z(() => {
    var l;
    r.isAuthenticated && !r.isLoading && !r.error && (console.info("[Host] new token issued", (l = r.user) == null ? void 0 : l.access_token.slice(-10)), t.setUser(r.user ? Mr(r.user) : null), t.sendToken());
  }, [
    r.error,
    r.isAuthenticated,
    r.isLoading,
    r.user,
    t,
    t.sendToken
  ]);
  const h = Pt(
    () => ({
      user: r.user ? Mr(r.user) : null,
      isLoading: r.isLoading,
      isAuthenticated: r.isAuthenticated,
      error: r.error,
      process: r.activeNavigator ? ri(r.activeNavigator) : void 0,
      signOutSilent: r.signoutSilent,
      singOutRedirect: u,
      sessionExpired: n
    }),
    [
      r.activeNavigator,
      r.error,
      r.isAuthenticated,
      r.isLoading,
      r.signoutSilent,
      r.user,
      u,
      n
    ]
  );
  return /* @__PURE__ */ tr.jsx(mn.Provider, { value: h, children: e });
}, ti = () => Vr(mn), ri = (e) => ni[e], ni = {
  signinRedirect: "signInRedirect",
  signinPopup: "signInPopup",
  signinSilent: "signInSilent",
  signoutRedirect: "signOutRedirect",
  signoutPopup: "signOutPopup",
  signoutSilent: "signOutSilent",
  signinResourceOwnerCredentials: "signInResourceOwnerCredentials"
}, Mr = (e) => ({
  accessToken: e.access_token,
  idToken: e.id_token,
  refreshToken: e.refresh_token,
  scope: e.scope
});
class si {
  constructor() {
    F(this, "user", null);
  }
  setUser(t) {
    this.user = t;
  }
  get accessToken() {
    var t;
    return ((t = this.user) == null ? void 0 : t.accessToken) ?? null;
  }
}
class ii {
  constructor(t, r = "token_channel") {
    F(this, "channel"), F(this, "createChannel", () => {
      const n = new BroadcastChannel(this.channelName);
      return n.addEventListener("message", (s) => {
        var o;
        s.data.type === "request_token" && (console.info("[Host] send a new token:", ((o = this.appUser.accessToken) == null ? void 0 : o.slice(-10)) ?? ""), n.postMessage({ type: "token", value: this.appUser.accessToken }));
      }), n;
    }), this.appUser = t, this.channelName = r, this.channel = this.createChannel();
  }
  // TODO maybe we don't need that
  updateChannel() {
    this.channel.close(), this.channel = this.createChannel();
  }
  close() {
    this.channel.close();
  }
  sendToken() {
    this.channel.postMessage({ type: "token", value: this.appUser.accessToken ?? "" });
  }
}
class oi {
  constructor(t) {
    F(this, "_tokenMessagingService"), F(this, "_appUser", new si()), this._config = t, this._tokenMessagingService = new ii(this._appUser);
  }
  get config() {
    return this._config;
  }
  setUser(t) {
    this._appUser.setUser(t);
  }
  get accessToken() {
    return this._appUser.accessToken;
  }
  sendToken() {
    this._tokenMessagingService.sendToken();
  }
  updateTokenChannel() {
    this._tokenMessagingService.updateChannel();
  }
}
const ai = "auth_redirect_uri", ci = "/login/callback", ui = ({
  children: e,
  authController: t
}) => /* @__PURE__ */ ft.jsx(Zs, { authController: t, children: /* @__PURE__ */ ft.jsx(li, { children: e }) }), li = ({ children: e }) => {
  const { isAuthenticated: t, singOutRedirect: r, isLoading: n, sessionExpired: s } = ti();
  z(() => {
    if (!n && !t) {
      const c = window.location.pathname + window.location.search;
      c !== ci && sessionStorage.setItem(ai, c);
    }
  }, [n, t]);
  const o = Pt(
    () => ({
      isLoading: n,
      isAuthenticated: t && !s,
      logout: r
    }),
    [t, n, s, r]
  );
  return /* @__PURE__ */ ft.jsx(fr.Provider, { value: o, children: e });
}, Ki = ({
  children: e,
  authController: t
}) => t.authType === "cookie" ? /* @__PURE__ */ ft.jsx(Dn, { children: e }) : /* @__PURE__ */ ft.jsx(ui, { authController: t.tokenAuthController, children: e });
class Vi {
  constructor(t, r) {
    Kt(this, "_tokenAuthController", null);
    Kt(this, "_authType");
    this._authType = r, this._authType === "token" && (this._tokenAuthController = new oi(t));
  }
  get authType() {
    return this._authType;
  }
  get tokenAuthController() {
    return this._tokenAuthController;
  }
}
var cr = function(e, t) {
  return cr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (r[s] = n[s]);
  }, cr(e, t);
};
function wr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  cr(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Ye = function() {
  return Ye = Object.assign || function(t) {
    for (var r, n = 1, s = arguments.length; n < s; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, Ye.apply(this, arguments);
};
function di(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
      t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (r[n[s]] = e[n[s]]);
  return r;
}
function hi(e, t, r, n) {
  function s(o) {
    return o instanceof r ? o : new r(function(c) {
      c(o);
    });
  }
  return new (r || (r = Promise))(function(o, c) {
    function u(p) {
      try {
        l(n.next(p));
      } catch (g) {
        c(g);
      }
    }
    function h(p) {
      try {
        l(n.throw(p));
      } catch (g) {
        c(g);
      }
    }
    function l(p) {
      p.done ? o(p.value) : s(p.value).then(u, h);
    }
    l((n = n.apply(e, t || [])).next());
  });
}
function fi(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, s, o, c;
  return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function u(l) {
    return function(p) {
      return h([l, p]);
    };
  }
  function h(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, l[0] && (r = 0)), r; ) try {
      if (n = 1, s && (o = l[0] & 2 ? s.return : l[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, l[1])).done) return o;
      switch (s = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
        case 0:
        case 1:
          o = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, s = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = l;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(l);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (p) {
      l = [6, p], s = 0;
    } finally {
      n = o = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function ht(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, o; n < s; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Qt = "Invariant Violation", qr = Object.setPrototypeOf, pi = qr === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : qr, wn = (
  /** @class */
  function(e) {
    wr(t, e);
    function t(r) {
      r === void 0 && (r = Qt);
      var n = e.call(this, typeof r == "number" ? Qt + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return n.framesToPop = 1, n.name = Qt, pi(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function et(e, t) {
  if (!e)
    throw new wn(t);
}
var vn = ["debug", "log", "warn", "error", "silent"], gi = vn.indexOf("log");
function Ut(e) {
  return function() {
    if (vn.indexOf(e) >= gi) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = Ut("debug"), e.log = Ut("log"), e.warn = Ut("warn"), e.error = Ut("error");
})(et || (et = {}));
var yn = "3.13.1";
function ut(e) {
  try {
    return e();
  } catch {
  }
}
const Dr = ut(function() {
  return globalThis;
}) || ut(function() {
  return window;
}) || ut(function() {
  return self;
}) || ut(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
ut(function() {
  return ut.constructor("return this")();
});
var $r = /* @__PURE__ */ new Map();
function _i(e) {
  var t = $r.get(e) || 1;
  return $r.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function mi(e, t) {
  var r = _i("stringifyForDisplay");
  return JSON.stringify(e, function(n, s) {
    return s === void 0 ? r : s;
  }, t).split(JSON.stringify(r)).join("<undefined>");
}
function Nt(e) {
  return function(t) {
    for (var r = [], n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
    if (typeof t == "number") {
      var s = t;
      t = vr(s), t || (t = yr(s, r), r = []);
    }
    e.apply(void 0, [t].concat(r));
  };
}
var wi = Object.assign(function(t, r) {
  for (var n = [], s = 2; s < arguments.length; s++)
    n[s - 2] = arguments[s];
  t || et(t, vr(r, n) || yr(r, n));
}, {
  debug: Nt(et.debug),
  log: Nt(et.log),
  warn: Nt(et.warn),
  error: Nt(et.error)
});
function bn(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return new wn(vr(e, t) || yr(e, t));
}
var Fr = Symbol.for("ApolloErrorMessageHandler_" + yn);
function Sn(e) {
  if (typeof e == "string")
    return e;
  try {
    return mi(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function vr(e, t) {
  if (t === void 0 && (t = []), !!e)
    return Dr[Fr] && Dr[Fr](e, t.map(Sn));
}
function yr(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: yn,
      message: e,
      args: t.map(Sn)
    })));
}
function vi(e) {
  return e !== null && typeof e == "object";
}
function yi(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function bi(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Si(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Si(e, t) {
  if (e) {
    if (typeof e == "string") return Wr(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Wr(e, t);
  }
}
function Wr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Hr(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function br(e, t, r) {
  return t && Hr(e.prototype, t), r && Hr(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Sr = function() {
  return typeof Symbol == "function";
}, kr = function(e) {
  return Sr() && !!Symbol[e];
}, Er = function(e) {
  return kr(e) ? Symbol[e] : "@@" + e;
};
Sr() && !kr("observable") && (Symbol.observable = Symbol("observable"));
var ki = Er("iterator"), ur = Er("observable"), kn = Er("species");
function Ft(e, t) {
  var r = e[t];
  if (r != null) {
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    return r;
  }
}
function Rt(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[kn], t === null && (t = void 0)), t !== void 0 ? t : ae;
}
function Ei(e) {
  return e instanceof ae;
}
function pt(e) {
  pt.log ? pt.log(e) : setTimeout(function() {
    throw e;
  });
}
function qt(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      pt(t);
    }
  });
}
function En(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var r = Ft(t, "unsubscribe");
        r && r.call(t);
      }
    } catch (n) {
      pt(n);
    }
}
function lr(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function Ti(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var r = 0; r < t.length && (Tn(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
      ;
  }
}
function Tn(e, t, r) {
  e._state = "running";
  var n = e._observer;
  try {
    var s = Ft(n, t);
    switch (t) {
      case "next":
        s && s.call(n, r);
        break;
      case "error":
        if (lr(e), s) s.call(n, r);
        else throw r;
        break;
      case "complete":
        lr(e), s && s.call(n);
        break;
    }
  } catch (o) {
    pt(o);
  }
  e._state === "closed" ? En(e) : e._state === "running" && (e._state = "ready");
}
function Xt(e, t, r) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: r
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: r
      }], qt(function() {
        return Ti(e);
      });
      return;
    }
    Tn(e, t, r);
  }
}
var Ri = /* @__PURE__ */ function() {
  function e(r, n) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var s = new Oi(this);
    try {
      this._cleanup = n.call(void 0, s);
    } catch (o) {
      s.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (lr(this), En(this));
  }, br(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), Oi = /* @__PURE__ */ function() {
  function e(r) {
    this._subscription = r;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Xt(this._subscription, "next", n);
  }, t.error = function(n) {
    Xt(this._subscription, "error", n);
  }, t.complete = function() {
    Xt(this._subscription, "complete");
  }, br(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), ae = /* @__PURE__ */ function() {
  function e(r) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new Ri(n, this._subscriber);
  }, t.forEach = function(n) {
    var s = this;
    return new Promise(function(o, c) {
      if (typeof n != "function") {
        c(new TypeError(n + " is not a function"));
        return;
      }
      function u() {
        h.unsubscribe(), o();
      }
      var h = s.subscribe({
        next: function(l) {
          try {
            n(l, u);
          } catch (p) {
            c(p), h.unsubscribe();
          }
        },
        error: c,
        complete: o
      });
    });
  }, t.map = function(n) {
    var s = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this);
    return new o(function(c) {
      return s.subscribe({
        next: function(u) {
          try {
            u = n(u);
          } catch (h) {
            return c.error(h);
          }
          c.next(u);
        },
        error: function(u) {
          c.error(u);
        },
        complete: function() {
          c.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var s = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this);
    return new o(function(c) {
      return s.subscribe({
        next: function(u) {
          try {
            if (!n(u)) return;
          } catch (h) {
            return c.error(h);
          }
          c.next(u);
        },
        error: function(u) {
          c.error(u);
        },
        complete: function() {
          c.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var s = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this), c = arguments.length > 1, u = !1, h = arguments[1], l = h;
    return new o(function(p) {
      return s.subscribe({
        next: function(g) {
          var k = !u;
          if (u = !0, !k || c)
            try {
              l = n(l, g);
            } catch (O) {
              return p.error(O);
            }
          else
            l = g;
        },
        error: function(g) {
          p.error(g);
        },
        complete: function() {
          if (!u && !c) return p.error(new TypeError("Cannot reduce an empty sequence"));
          p.next(l), p.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    var u = Rt(this);
    return new u(function(h) {
      var l, p = 0;
      function g(k) {
        l = k.subscribe({
          next: function(O) {
            h.next(O);
          },
          error: function(O) {
            h.error(O);
          },
          complete: function() {
            p === o.length ? (l = void 0, h.complete()) : g(u.from(o[p++]));
          }
        });
      }
      return g(n), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var s = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var o = Rt(this);
    return new o(function(c) {
      var u = [], h = s.subscribe({
        next: function(p) {
          if (n)
            try {
              p = n(p);
            } catch (k) {
              return c.error(k);
            }
          var g = o.from(p).subscribe({
            next: function(k) {
              c.next(k);
            },
            error: function(k) {
              c.error(k);
            },
            complete: function() {
              var k = u.indexOf(g);
              k >= 0 && u.splice(k, 1), l();
            }
          });
          u.push(g);
        },
        error: function(p) {
          c.error(p);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        h.closed && u.length === 0 && c.complete();
      }
      return function() {
        u.forEach(function(p) {
          return p.unsubscribe();
        }), h.unsubscribe();
      };
    });
  }, t[ur] = function() {
    return this;
  }, e.from = function(n) {
    var s = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var o = Ft(n, ur);
    if (o) {
      var c = o.call(n);
      if (Object(c) !== c) throw new TypeError(c + " is not an object");
      return Ei(c) && c.constructor === s ? c : new s(function(u) {
        return c.subscribe(u);
      });
    }
    if (kr("iterator") && (o = Ft(n, ki), o))
      return new s(function(u) {
        qt(function() {
          if (!u.closed) {
            for (var h = bi(o.call(n)), l; !(l = h()).done; ) {
              var p = l.value;
              if (u.next(p), u.closed) return;
            }
            u.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new s(function(u) {
        qt(function() {
          if (!u.closed) {
            for (var h = 0; h < n.length; ++h)
              if (u.next(n[h]), u.closed) return;
            u.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, s = new Array(n), o = 0; o < n; o++)
      s[o] = arguments[o];
    var c = typeof this == "function" ? this : e;
    return new c(function(u) {
      qt(function() {
        if (!u.closed) {
          for (var h = 0; h < s.length; ++h)
            if (u.next(s[h]), u.closed) return;
          u.complete();
        }
      });
    });
  }, br(e, null, [{
    key: kn,
    get: function() {
      return this;
    }
  }]), e;
}();
Sr() && Object.defineProperty(ae, Symbol("extensions"), {
  value: {
    symbol: ur,
    hostReportError: pt
  },
  configurable: !0
});
function Ii(e) {
  var t, r = e.Symbol;
  if (typeof r == "function")
    if (r.observable)
      t = r.observable;
    else {
      typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var lt;
typeof self < "u" ? lt = self : typeof window < "u" ? lt = window : typeof global < "u" ? lt = global : typeof module < "u" ? lt = module : lt = Function("return this")();
Ii(lt);
var Jr = ae.prototype, zr = "@@observable";
Jr[zr] || (Jr[zr] = function() {
  return this;
});
function xi(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, n = Object.keys(e); r < n.length; r++) {
    var s = n[r];
    if (t.indexOf(s) < 0)
      throw bn(46, s);
  }
  return e;
}
function Ci(e, t) {
  var r = Ye({}, e), n = function(o) {
    typeof o == "function" ? r = Ye(Ye({}, r), o(r)) : r = Ye(Ye({}, r), o);
  }, s = function() {
    return Ye({}, r);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: s
  }), t;
}
function Pi(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? yi(t.query) || void 0 : ""), t;
}
function Kr(e, t) {
  return t ? t(e) : ae.of();
}
function Ot(e) {
  return typeof e == "function" ? new Tr(e) : e;
}
function Lt(e) {
  return e.request.length <= 1;
}
var Tr = (
  /** @class */
  function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return ae.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Ot).reduce(function(r, n) {
        return r.concat(n);
      });
    }, e.split = function(t, r, n) {
      var s = Ot(r), o = Ot(n || new e(Kr)), c;
      return Lt(s) && Lt(o) ? c = new e(function(u) {
        return t(u) ? s.request(u) || ae.of() : o.request(u) || ae.of();
      }) : c = new e(function(u, h) {
        return t(u) ? s.request(u, h) || ae.of() : o.request(u, h) || ae.of();
      }), Object.assign(c, { left: s, right: o });
    }, e.execute = function(t, r) {
      return t.request(Ci(r.context, Pi(xi(r)))) || ae.of();
    }, e.concat = function(t, r) {
      var n = Ot(t);
      if (Lt(n))
        return globalThis.__DEV__ !== !1 && wi.warn(38, n), n;
      var s = Ot(r), o;
      return Lt(s) ? o = new e(function(c) {
        return n.request(c, function(u) {
          return s.request(u) || ae.of();
        }) || ae.of();
      }) : o = new e(function(c, u) {
        return n.request(c, function(h) {
          return s.request(h, u) || ae.of();
        }) || ae.of();
      }), Object.assign(o, { left: n, right: s });
    }, e.prototype.split = function(t, r, n) {
      return this.concat(e.split(t, r, n || new e(Kr)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, r) {
      throw bn(39);
    }, e.prototype.onError = function(t, r) {
      if (r && r.error)
        return r.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return this.onError = t, this;
    }, e;
  }()
);
function Ai(e) {
  return new Tr(function(t, r) {
    var n = di(t, []);
    return new ae(function(s) {
      var o, c = !1;
      return Promise.resolve(n).then(function(u) {
        return e(u, t.getContext());
      }).then(t.setContext).then(function() {
        c || (o = r(t).subscribe({
          next: s.next.bind(s),
          error: s.error.bind(s),
          complete: s.complete.bind(s)
        }));
      }).catch(s.error.bind(s)), function() {
        c = !0, o && o.unsubscribe();
      };
    });
  });
}
const Bi = (e) => e.authType === "cookie" ? {
  authMiddleware: null,
  sameOriginHeader: { credentials: "same-origin" }
} : {
  authMiddleware: Ai((r, { headers: n }) => ({
    headers: {
      ...n,
      Authorization: `Bearer ${e.tokenAuthController.accessToken ?? ""}`
    }
  })),
  sameOriginHeader: {}
}, ji = /^(?:.+; )?XSRF-TOKEN=([^;]+).*/, Yi = () => new Br((e, t) => {
  const r = document.cookie.match(ji);
  return r && e.setContext(({ headers: n = {} }) => ({
    headers: { ...n, "X-CSRF-Token": r[1] }
  })), t(e);
});
function Ui(e) {
  var t = e || {}, r = t.initial, n = r === void 0 ? 300 : r, s = t.jitter, o = s === void 0 ? !0 : s, c = t.max, u = c === void 0 ? 1 / 0 : c, h = o ? n : n / 2;
  return function(p) {
    var g = Math.min(u, h * Math.pow(2, p));
    return o && (g = Math.random() * g), g;
  };
}
function Ni(e) {
  var t = e || {}, r = t.retryIf, n = t.max, s = n === void 0 ? 5 : n;
  return function(c, u, h) {
    return c >= s ? !1 : r ? r(h, u) : !!h;
  };
}
var Rn = Symbol();
function Li(e) {
  return e.extensions ? Array.isArray(e.extensions[Rn]) : !1;
}
var Mi = function(e) {
  var t = ht(ht(ht([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(r) {
    return vi(r) && r.message || "Error message not found.";
  }).join(`
`);
}, qi = (
  /** @class */
  function(e) {
    wr(t, e);
    function t(r) {
      var n = r.graphQLErrors, s = r.protocolErrors, o = r.clientErrors, c = r.networkError, u = r.errorMessage, h = r.extraInfo, l = e.call(this, u) || this;
      return l.name = "ApolloError", l.graphQLErrors = n || [], l.protocolErrors = s || [], l.clientErrors = o || [], l.networkError = c || null, l.message = u || Mi(l), l.extraInfo = h, l.cause = ht(ht(ht([
        c
      ], n || [], !0), s || [], !0), o || [], !0).find(function(p) {
        return !!p;
      }) || null, l.__proto__ = t.prototype, l;
    }
    return t;
  }(Error)
), Di = (
  /** @class */
  function() {
    function e(t, r, n, s, o) {
      var c = this;
      this.observer = t, this.operation = r, this.forward = n, this.delayFor = s, this.retryIf = o, this.retryCount = 0, this.currentSubscription = null, this.onError = function(u) {
        return hi(c, void 0, void 0, function() {
          var h;
          return fi(this, function(l) {
            switch (l.label) {
              case 0:
                return this.retryCount += 1, [4, this.retryIf(this.retryCount, this.operation, u)];
              case 1:
                return h = l.sent(), h ? (this.scheduleRetry(this.delayFor(this.retryCount, this.operation, u)), [
                  2
                  /*return*/
                ]) : (this.observer.error(u), [
                  2
                  /*return*/
                ]);
            }
          });
        });
      }, this.try();
    }
    return e.prototype.cancel = function() {
      this.currentSubscription && this.currentSubscription.unsubscribe(), clearTimeout(this.timerId), this.timerId = void 0, this.currentSubscription = null;
    }, e.prototype.try = function() {
      var t = this;
      this.currentSubscription = this.forward(this.operation).subscribe({
        next: function(r) {
          var n;
          if (Li(r)) {
            t.onError(new qi({
              protocolErrors: r.extensions[Rn]
            })), (n = t.currentSubscription) === null || n === void 0 || n.unsubscribe();
            return;
          }
          t.observer.next(r);
        },
        error: this.onError,
        complete: this.observer.complete.bind(this.observer)
      });
    }, e.prototype.scheduleRetry = function(t) {
      var r = this;
      if (this.timerId)
        throw new Error("RetryLink BUG! Encountered overlapping retries");
      this.timerId = setTimeout(function() {
        r.timerId = void 0, r.try();
      }, t);
    }, e;
  }()
), $i = (
  /** @class */
  function(e) {
    wr(t, e);
    function t(r) {
      var n = e.call(this) || this, s = r || {}, o = s.attempts, c = s.delay;
      return n.delayFor = typeof c == "function" ? c : Ui(c), n.retryIf = typeof o == "function" ? o : Ni(o), n;
    }
    return t.prototype.request = function(r, n) {
      var s = this;
      return new ae(function(o) {
        var c = new Di(o, r, n, s.delayFor, s.retryIf);
        return function() {
          c.cancel();
        };
      });
    }, t;
  }(Tr)
);
const Gi = () => new $i({
  attempts: {
    retryIf: async (e, t) => {
      const r = t.query.definitions.some(
        (s) => s.kind === "OperationDefinition" && s.operation === "mutation"
      ), n = e.statusCode;
      if (n === 401) {
        const s = await fetch("/about", {
          credentials: "same-origin"
        });
        return s.status === 200 && s.headers.get("Content-Type") === "application/json" ? !0 : (Qr(), !1);
      }
      return !r && n >= 500 || n === 403 && document.cookie !== "";
    }
  }
});
export {
  ai as AUTH_REDIRECT_KEY,
  Vi as AuthController,
  Ki as AuthProvider,
  ji as cookieRE,
  Qr as onAuthError,
  zi as refreshLink,
  qn as requestSent,
  Ji as useAuth,
  Gi as withApolloRetryLink,
  Bi as withAuthMiddleware,
  Yi as withXCSRFToken
};
//# sourceMappingURL=kyc-authentication.es.js.map
